import * as request from 'superagent';

/**
 * A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
 * @class CBioPortalAPI
 * @param {(string)} [domainOrOptions] - The project domain.
 */
var CBioPortalAPI = /** @class */ (function () {
    function CBioPortalAPI(domain) {
        Object.defineProperty(this, "domain", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "errorHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        if (domain) {
            this.domain = domain;
        }
    }
    Object.defineProperty(CBioPortalAPI.prototype, "getDomain", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.domain;
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "addErrorHandler", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (handler) {
            this.errorHandlers.push(handler);
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "request", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (method, url, body, headers, queryParameters, form, reject, resolve, errorHandlers) {
            var req = new request.Request(method, url)
                .query(queryParameters);
            Object.keys(headers).forEach(function (key) {
                req.set(key, headers[key]);
            });
            if (body) {
                req.send(body);
            }
            if (typeof (body) === 'object' && !(body.constructor.name === 'Buffer')) {
                req.set('Content-Type', 'application/json');
            }
            if (Object.keys(form).length > 0) {
                req.type('form');
                req.send(form);
            }
            req.end(function (error, response) {
                if (error || !response.ok) {
                    reject(error);
                    errorHandlers.forEach(function (handler) { return handler(error); });
                }
                else {
                    resolve(response);
                }
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllCancerTypesUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/cancer-types';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all cancer types
     * @method
     * @name CBioPortalAPI#getAllCancerTypesUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllCancerTypesUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/cancer-types';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all cancer types
     * @method
     * @name CBioPortalAPI#getAllCancerTypesUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllCancerTypesUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllCancerTypesUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getCancerTypeUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/cancer-types/{cancerTypeId}';
            path = path.replace('{cancerTypeId}', parameters['cancerTypeId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get a cancer type
     * @method
     * @name CBioPortalAPI#getCancerTypeUsingGET
     * @param {string} cancerTypeId - Cancer Type ID e.g. acc
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getCancerTypeUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/cancer-types/{cancerTypeId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{cancerTypeId}', parameters['cancerTypeId'] + '');
                if (parameters['cancerTypeId'] === undefined) {
                    reject(new Error('Missing required  parameter: cancerTypeId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get a cancer type
     * @method
     * @name CBioPortalAPI#getCancerTypeUsingGET
     * @param {string} cancerTypeId - Cancer Type ID e.g. acc
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getCancerTypeUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getCancerTypeUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalAttributesUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-attributes';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all clinical attributes
     * @method
     * @name CBioPortalAPI#getAllClinicalAttributesUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalAttributesUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-attributes';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all clinical attributes
     * @method
     * @name CBioPortalAPI#getAllClinicalAttributesUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalAttributesUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllClinicalAttributesUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchClinicalAttributesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-attributes/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch clinical attributes
     * @method
     * @name CBioPortalAPI#fetchClinicalAttributesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchClinicalAttributesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-attributes/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['studyIds'] !== undefined) {
                    body = parameters['studyIds'];
                }
                if (parameters['studyIds'] === undefined) {
                    reject(new Error('Missing required  parameter: studyIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch clinical attributes
     * @method
     * @name CBioPortalAPI#fetchClinicalAttributesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchClinicalAttributesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchClinicalAttributesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchClinicalDataUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-data/fetch';
            if (parameters['clinicalDataType'] !== undefined) {
                queryParameters['clinicalDataType'] = parameters['clinicalDataType'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch clinical data by patient IDs or sample IDs (all studies)
     * @method
     * @name CBioPortalAPI#fetchClinicalDataUsingPOST
     * @param {string} clinicalDataType - Type of the clinical data
     * @param {string} projection - Level of detail of the response
     * @param {} clinicalDataMultiStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchClinicalDataUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-data/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['clinicalDataType'] !== undefined) {
                    queryParameters['clinicalDataType'] = parameters['clinicalDataType'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['clinicalDataMultiStudyFilter'] !== undefined) {
                    body = parameters['clinicalDataMultiStudyFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch clinical data by patient IDs or sample IDs (all studies)
     * @method
     * @name CBioPortalAPI#fetchClinicalDataUsingPOST
     * @param {string} clinicalDataType - Type of the clinical data
     * @param {string} projection - Level of detail of the response
     * @param {} clinicalDataMultiStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchClinicalDataUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchClinicalDataUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchCopyNumberSegmentsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/copy-number-segments/fetch';
            if (parameters['chromosome'] !== undefined) {
                queryParameters['chromosome'] = parameters['chromosome'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch copy number segments by sample ID
     * @method
     * @name CBioPortalAPI#fetchCopyNumberSegmentsUsingPOST
     * @param {string} chromosome - Chromosome
     * @param {string} projection - Level of detail of the response
     * @param {} sampleIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchCopyNumberSegmentsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/copy-number-segments/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['chromosome'] !== undefined) {
                    queryParameters['chromosome'] = parameters['chromosome'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['sampleIdentifiers'] !== undefined) {
                    body = parameters['sampleIdentifiers'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch copy number segments by sample ID
     * @method
     * @name CBioPortalAPI#fetchCopyNumberSegmentsUsingPOST
     * @param {string} chromosome - Chromosome
     * @param {string} projection - Level of detail of the response
     * @param {} sampleIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchCopyNumberSegmentsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchCopyNumberSegmentsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenePanelDataInMultipleMolecularProfilesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/gene-panel-data/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch gene panel data
     * @method
     * @name CBioPortalAPI#fetchGenePanelDataInMultipleMolecularProfilesUsingPOST
     * @param {} genePanelDataMultipleStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenePanelDataInMultipleMolecularProfilesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/gene-panel-data/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['genePanelDataMultipleStudyFilter'] !== undefined) {
                    body = parameters['genePanelDataMultipleStudyFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch gene panel data
     * @method
     * @name CBioPortalAPI#fetchGenePanelDataInMultipleMolecularProfilesUsingPOST
     * @param {} genePanelDataMultipleStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenePanelDataInMultipleMolecularProfilesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenePanelDataInMultipleMolecularProfilesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllGenePanelsUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/gene-panels';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all gene panels
     * @method
     * @name CBioPortalAPI#getAllGenePanelsUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllGenePanelsUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/gene-panels';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all gene panels
     * @method
     * @name CBioPortalAPI#getAllGenePanelsUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllGenePanelsUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllGenePanelsUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenePanelsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/gene-panels/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get gene panel
     * @method
     * @name CBioPortalAPI#fetchGenePanelsUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} genePanelIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenePanelsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/gene-panels/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['genePanelIds'] !== undefined) {
                    body = parameters['genePanelIds'];
                }
                if (parameters['genePanelIds'] === undefined) {
                    reject(new Error('Missing required  parameter: genePanelIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get gene panel
     * @method
     * @name CBioPortalAPI#fetchGenePanelsUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} genePanelIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenePanelsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenePanelsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getGenePanelUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/gene-panels/{genePanelId}';
            path = path.replace('{genePanelId}', parameters['genePanelId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get gene panel
     * @method
     * @name CBioPortalAPI#getGenePanelUsingGET
     * @param {string} genePanelId - Gene Panel ID e.g. NSCLC_UNITO_2016_PANEL
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGenePanelUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/gene-panels/{genePanelId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{genePanelId}', parameters['genePanelId'] + '');
                if (parameters['genePanelId'] === undefined) {
                    reject(new Error('Missing required  parameter: genePanelId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get gene panel
     * @method
     * @name CBioPortalAPI#getGenePanelUsingGET
     * @param {string} genePanelId - Gene Panel ID e.g. NSCLC_UNITO_2016_PANEL
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGenePanelUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getGenePanelUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getGenericAssayDataInMolecularProfileUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic-assay-data/{molecularProfileId}/generic-assay/{genericAssayStableId}';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            path = path.replace('{genericAssayStableId}', parameters['genericAssayStableId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get generic_assay_data in a molecular profile
     * @method
     * @name CBioPortalAPI#getGenericAssayDataInMolecularProfileUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID
     * @param {string} genericAssayStableId - Generic Assay stable ID
     * @param {string} projection - Level of detail of the response
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGenericAssayDataInMolecularProfileUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic-assay-data/{molecularProfileId}/generic-assay/{genericAssayStableId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                path = path.replace('{genericAssayStableId}', parameters['genericAssayStableId'] + '');
                if (parameters['genericAssayStableId'] === undefined) {
                    reject(new Error('Missing required  parameter: genericAssayStableId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get generic_assay_data in a molecular profile
     * @method
     * @name CBioPortalAPI#getGenericAssayDataInMolecularProfileUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID
     * @param {string} genericAssayStableId - Generic Assay stable ID
     * @param {string} projection - Level of detail of the response
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGenericAssayDataInMolecularProfileUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getGenericAssayDataInMolecularProfileUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getGenericAssayMeta_gaUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic-assay-meta/generic-assay/{genericAssayStableId}';
            path = path.replace('{genericAssayStableId}', parameters['genericAssayStableId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch meta data for generic-assay by ID
     * @method
     * @name CBioPortalAPI#getGenericAssayMeta_gaUsingGET
     * @param {string} genericAssayStableId - Generic Assay stable ID
     * @param {string} projection - Level of detail of the response
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGenericAssayMeta_gaUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic-assay-meta/generic-assay/{genericAssayStableId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{genericAssayStableId}', parameters['genericAssayStableId'] + '');
                if (parameters['genericAssayStableId'] === undefined) {
                    reject(new Error('Missing required  parameter: genericAssayStableId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch meta data for generic-assay by ID
     * @method
     * @name CBioPortalAPI#getGenericAssayMeta_gaUsingGET
     * @param {string} genericAssayStableId - Generic Assay stable ID
     * @param {string} projection - Level of detail of the response
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGenericAssayMeta_gaUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getGenericAssayMeta_gaUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getGenericAssayMetaUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic-assay-meta/{molecularProfileId}';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch meta data for generic-assay by ID
     * @method
     * @name CBioPortalAPI#getGenericAssayMetaUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID
     * @param {string} projection - Level of detail of the response
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGenericAssayMetaUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic-assay-meta/{molecularProfileId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch meta data for generic-assay by ID
     * @method
     * @name CBioPortalAPI#getGenericAssayMetaUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID
     * @param {string} projection - Level of detail of the response
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGenericAssayMetaUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getGenericAssayMetaUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenericAssayDataInMultipleMolecularProfilesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic_assay_data/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch generic_assay_data
     * @method
     * @name CBioPortalAPI#fetchGenericAssayDataInMultipleMolecularProfilesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} genericAssayDataMultipleStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenericAssayDataInMultipleMolecularProfilesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic_assay_data/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['genericAssayDataMultipleStudyFilter'] !== undefined) {
                    body = parameters['genericAssayDataMultipleStudyFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch generic_assay_data
     * @method
     * @name CBioPortalAPI#fetchGenericAssayDataInMultipleMolecularProfilesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} genericAssayDataMultipleStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenericAssayDataInMultipleMolecularProfilesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenericAssayDataInMultipleMolecularProfilesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenericAssayDataInMolecularProfileUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic_assay_data/{molecularProfileId}/fetch';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * fetch generic_assay_data in a molecular profile
     * @method
     * @name CBioPortalAPI#fetchGenericAssayDataInMolecularProfileUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID
     * @param {string} projection - Level of detail of the response
     * @param {} genericAssayFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenericAssayDataInMolecularProfileUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic_assay_data/{molecularProfileId}/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['genericAssayFilter'] !== undefined) {
                    body = parameters['genericAssayFilter'];
                }
                if (parameters['genericAssayFilter'] === undefined) {
                    reject(new Error('Missing required  parameter: genericAssayFilter'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * fetch generic_assay_data in a molecular profile
     * @method
     * @name CBioPortalAPI#fetchGenericAssayDataInMolecularProfileUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID
     * @param {string} projection - Level of detail of the response
     * @param {} genericAssayFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenericAssayDataInMolecularProfileUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenericAssayDataInMolecularProfileUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenericAssayMetaUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic_assay_meta/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch meta data for generic-assay by ID
     * @method
     * @name CBioPortalAPI#fetchGenericAssayMetaUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} genericAssayMetaFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenericAssayMetaUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic_assay_meta/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['genericAssayMetaFilter'] !== undefined) {
                    body = parameters['genericAssayMetaFilter'];
                }
                if (parameters['genericAssayMetaFilter'] === undefined) {
                    reject(new Error('Missing required  parameter: genericAssayMetaFilter'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch meta data for generic-assay by ID
     * @method
     * @name CBioPortalAPI#fetchGenericAssayMetaUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} genericAssayMetaFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenericAssayMetaUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenericAssayMetaUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllGenesUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genes';
            if (parameters['keyword'] !== undefined) {
                queryParameters['keyword'] = parameters['keyword'];
            }
            if (parameters['alias'] !== undefined) {
                queryParameters['alias'] = parameters['alias'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all genes
     * @method
     * @name CBioPortalAPI#getAllGenesUsingGET
     * @param {string} keyword - Search keyword that applies to hugo gene symbol of the genes
     * @param {string} alias - Alias of the gene
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllGenesUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genes';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters['keyword'] !== undefined) {
                    queryParameters['keyword'] = parameters['keyword'];
                }
                if (parameters['alias'] !== undefined) {
                    queryParameters['alias'] = parameters['alias'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all genes
     * @method
     * @name CBioPortalAPI#getAllGenesUsingGET
     * @param {string} keyword - Search keyword that applies to hugo gene symbol of the genes
     * @param {string} alias - Alias of the gene
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllGenesUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllGenesUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genes/fetch';
            if (parameters['geneIdType'] !== undefined) {
                queryParameters['geneIdType'] = parameters['geneIdType'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch genes by ID
     * @method
     * @name CBioPortalAPI#fetchGenesUsingPOST
     * @param {string} geneIdType - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     * @param {string} projection - Level of detail of the response
     * @param {} geneIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genes/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['geneIdType'] !== undefined) {
                    queryParameters['geneIdType'] = parameters['geneIdType'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['geneIds'] !== undefined) {
                    body = parameters['geneIds'];
                }
                if (parameters['geneIds'] === undefined) {
                    reject(new Error('Missing required  parameter: geneIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch genes by ID
     * @method
     * @name CBioPortalAPI#fetchGenesUsingPOST
     * @param {string} geneIdType - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     * @param {string} projection - Level of detail of the response
     * @param {} geneIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchGenesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getGeneUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genes/{geneId}';
            path = path.replace('{geneId}', parameters['geneId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get a gene
     * @method
     * @name CBioPortalAPI#getGeneUsingGET
     * @param {string} geneId - Entrez Gene ID or Hugo Gene Symbol e.g. 1 or A1BG
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGeneUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genes/{geneId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{geneId}', parameters['geneId'] + '');
                if (parameters['geneId'] === undefined) {
                    reject(new Error('Missing required  parameter: geneId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get a gene
     * @method
     * @name CBioPortalAPI#getGeneUsingGET
     * @param {string} geneId - Entrez Gene ID or Hugo Gene Symbol e.g. 1 or A1BG
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGeneUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getGeneUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAliasesOfGeneUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genes/{geneId}/aliases';
            path = path.replace('{geneId}', parameters['geneId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get aliases of a gene
     * @method
     * @name CBioPortalAPI#getAliasesOfGeneUsingGET
     * @param {string} geneId - Entrez Gene ID or Hugo Gene Symbol e.g. 1 or A1BG
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAliasesOfGeneUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genes/{geneId}/aliases';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{geneId}', parameters['geneId'] + '');
                if (parameters['geneId'] === undefined) {
                    reject(new Error('Missing required  parameter: geneId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get aliases of a gene
     * @method
     * @name CBioPortalAPI#getAliasesOfGeneUsingGET
     * @param {string} geneId - Entrez Gene ID or Hugo Gene Symbol e.g. 1 or A1BG
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAliasesOfGeneUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAliasesOfGeneUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getServerStatusUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/health';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get the running status of the server
     * @method
     * @name CBioPortalAPI#getServerStatusUsingGET
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getServerStatusUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/health';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get the running status of the server
     * @method
     * @name CBioPortalAPI#getServerStatusUsingGET
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getServerStatusUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getServerStatusUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getInfoUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/info';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get information about the running instance
     * @method
     * @name CBioPortalAPI#getInfoUsingGET
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getInfoUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/info';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get information about the running instance
     * @method
     * @name CBioPortalAPI#getInfoUsingGET
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getInfoUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getInfoUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMolecularDataInMultipleMolecularProfilesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-data/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch molecular data
     * @method
     * @name CBioPortalAPI#fetchMolecularDataInMultipleMolecularProfilesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} molecularDataMultipleStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMolecularDataInMultipleMolecularProfilesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-data/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['molecularDataMultipleStudyFilter'] !== undefined) {
                    body = parameters['molecularDataMultipleStudyFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch molecular data
     * @method
     * @name CBioPortalAPI#fetchMolecularDataInMultipleMolecularProfilesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} molecularDataMultipleStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMolecularDataInMultipleMolecularProfilesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchMolecularDataInMultipleMolecularProfilesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllMolecularProfilesUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all molecular profiles
     * @method
     * @name CBioPortalAPI#getAllMolecularProfilesUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllMolecularProfilesUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all molecular profiles
     * @method
     * @name CBioPortalAPI#getAllMolecularProfilesUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllMolecularProfilesUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllMolecularProfilesUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMolecularProfilesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch molecular profiles
     * @method
     * @name CBioPortalAPI#fetchMolecularProfilesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} molecularProfileFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMolecularProfilesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['molecularProfileFilter'] !== undefined) {
                    body = parameters['molecularProfileFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch molecular profiles
     * @method
     * @name CBioPortalAPI#fetchMolecularProfilesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} molecularProfileFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMolecularProfilesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchMolecularProfilesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getMolecularProfileUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get molecular profile
     * @method
     * @name CBioPortalAPI#getMolecularProfileUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_mutations
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getMolecularProfileUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get molecular profile
     * @method
     * @name CBioPortalAPI#getMolecularProfileUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_mutations
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getMolecularProfileUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getMolecularProfileUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getDiscreteCopyNumbersInMolecularProfileUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/discrete-copy-number';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters['sampleListId'] !== undefined) {
                queryParameters['sampleListId'] = parameters['sampleListId'];
            }
            if (parameters['discreteCopyNumberEventType'] !== undefined) {
                queryParameters['discreteCopyNumberEventType'] = parameters['discreteCopyNumberEventType'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get discrete copy number alterations in a molecular profile
     * @method
     * @name CBioPortalAPI#getDiscreteCopyNumbersInMolecularProfileUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_gistic
     * @param {string} sampleListId - Sample List ID e.g. acc_tcga_all
     * @param {string} discreteCopyNumberEventType - Type of the copy number event
     * @param {string} projection - Level of detail of the response
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getDiscreteCopyNumbersInMolecularProfileUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/discrete-copy-number';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['sampleListId'] !== undefined) {
                    queryParameters['sampleListId'] = parameters['sampleListId'];
                }
                if (parameters['sampleListId'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleListId'));
                    return;
                }
                if (parameters['discreteCopyNumberEventType'] !== undefined) {
                    queryParameters['discreteCopyNumberEventType'] = parameters['discreteCopyNumberEventType'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get discrete copy number alterations in a molecular profile
     * @method
     * @name CBioPortalAPI#getDiscreteCopyNumbersInMolecularProfileUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_gistic
     * @param {string} sampleListId - Sample List ID e.g. acc_tcga_all
     * @param {string} discreteCopyNumberEventType - Type of the copy number event
     * @param {string} projection - Level of detail of the response
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getDiscreteCopyNumbersInMolecularProfileUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getDiscreteCopyNumbersInMolecularProfileUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchDiscreteCopyNumbersInMolecularProfileUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/discrete-copy-number/fetch';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters['discreteCopyNumberEventType'] !== undefined) {
                queryParameters['discreteCopyNumberEventType'] = parameters['discreteCopyNumberEventType'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch discrete copy number alterations in a molecular profile by sample ID
     * @method
     * @name CBioPortalAPI#fetchDiscreteCopyNumbersInMolecularProfileUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_gistic
     * @param {string} discreteCopyNumberEventType - Type of the copy number event
     * @param {string} projection - Level of detail of the response
     * @param {} discreteCopyNumberFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchDiscreteCopyNumbersInMolecularProfileUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/discrete-copy-number/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['discreteCopyNumberEventType'] !== undefined) {
                    queryParameters['discreteCopyNumberEventType'] = parameters['discreteCopyNumberEventType'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['discreteCopyNumberFilter'] !== undefined) {
                    body = parameters['discreteCopyNumberFilter'];
                }
                if (parameters['discreteCopyNumberFilter'] === undefined) {
                    reject(new Error('Missing required  parameter: discreteCopyNumberFilter'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch discrete copy number alterations in a molecular profile by sample ID
     * @method
     * @name CBioPortalAPI#fetchDiscreteCopyNumbersInMolecularProfileUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_gistic
     * @param {string} discreteCopyNumberEventType - Type of the copy number event
     * @param {string} projection - Level of detail of the response
     * @param {} discreteCopyNumberFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchDiscreteCopyNumbersInMolecularProfileUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchDiscreteCopyNumbersInMolecularProfileUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getGenePanelDataUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/gene-panel-data/fetch';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get gene panel data
     * @method
     * @name CBioPortalAPI#getGenePanelDataUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. nsclc_unito_2016_mutations
     * @param {} genePanelDataFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGenePanelDataUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/gene-panel-data/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['genePanelDataFilter'] !== undefined) {
                    body = parameters['genePanelDataFilter'];
                }
                if (parameters['genePanelDataFilter'] === undefined) {
                    reject(new Error('Missing required  parameter: genePanelDataFilter'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get gene panel data
     * @method
     * @name CBioPortalAPI#getGenePanelDataUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. nsclc_unito_2016_mutations
     * @param {} genePanelDataFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getGenePanelDataUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getGenePanelDataUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllMolecularDataInMolecularProfileUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/molecular-data';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters['sampleListId'] !== undefined) {
                queryParameters['sampleListId'] = parameters['sampleListId'];
            }
            if (parameters['entrezGeneId'] !== undefined) {
                queryParameters['entrezGeneId'] = parameters['entrezGeneId'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all molecular data in a molecular profile
     * @method
     * @name CBioPortalAPI#getAllMolecularDataInMolecularProfileUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_rna_seq_v2_mrna
     * @param {string} sampleListId - Sample List ID e.g. acc_tcga_all
     * @param {integer} entrezGeneId - Entrez Gene ID e.g. 1
     * @param {string} projection - Level of detail of the response
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllMolecularDataInMolecularProfileUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/molecular-data';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['sampleListId'] !== undefined) {
                    queryParameters['sampleListId'] = parameters['sampleListId'];
                }
                if (parameters['sampleListId'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleListId'));
                    return;
                }
                if (parameters['entrezGeneId'] !== undefined) {
                    queryParameters['entrezGeneId'] = parameters['entrezGeneId'];
                }
                if (parameters['entrezGeneId'] === undefined) {
                    reject(new Error('Missing required  parameter: entrezGeneId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all molecular data in a molecular profile
     * @method
     * @name CBioPortalAPI#getAllMolecularDataInMolecularProfileUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_rna_seq_v2_mrna
     * @param {string} sampleListId - Sample List ID e.g. acc_tcga_all
     * @param {integer} entrezGeneId - Entrez Gene ID e.g. 1
     * @param {string} projection - Level of detail of the response
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllMolecularDataInMolecularProfileUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllMolecularDataInMolecularProfileUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchAllMolecularDataInMolecularProfileUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/molecular-data/fetch';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch molecular data in a molecular profile
     * @method
     * @name CBioPortalAPI#fetchAllMolecularDataInMolecularProfileUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_rna_seq_v2_mrna
     * @param {string} projection - Level of detail of the response
     * @param {} molecularDataFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchAllMolecularDataInMolecularProfileUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/molecular-data/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['molecularDataFilter'] !== undefined) {
                    body = parameters['molecularDataFilter'];
                }
                if (parameters['molecularDataFilter'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularDataFilter'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch molecular data in a molecular profile
     * @method
     * @name CBioPortalAPI#fetchAllMolecularDataInMolecularProfileUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_rna_seq_v2_mrna
     * @param {string} projection - Level of detail of the response
     * @param {} molecularDataFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchAllMolecularDataInMolecularProfileUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchAllMolecularDataInMolecularProfileUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getMutationsInMolecularProfileBySampleListIdUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/mutations';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters['sampleListId'] !== undefined) {
                queryParameters['sampleListId'] = parameters['sampleListId'];
            }
            if (parameters['entrezGeneId'] !== undefined) {
                queryParameters['entrezGeneId'] = parameters['entrezGeneId'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get mutations in a molecular profile by Sample List ID
     * @method
     * @name CBioPortalAPI#getMutationsInMolecularProfileBySampleListIdUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_mutations
     * @param {string} sampleListId - Sample List ID e.g. acc_tcga_all
     * @param {integer} entrezGeneId - Entrez Gene ID
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getMutationsInMolecularProfileBySampleListIdUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/mutations';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['sampleListId'] !== undefined) {
                    queryParameters['sampleListId'] = parameters['sampleListId'];
                }
                if (parameters['sampleListId'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleListId'));
                    return;
                }
                if (parameters['entrezGeneId'] !== undefined) {
                    queryParameters['entrezGeneId'] = parameters['entrezGeneId'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get mutations in a molecular profile by Sample List ID
     * @method
     * @name CBioPortalAPI#getMutationsInMolecularProfileBySampleListIdUsingGET
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_mutations
     * @param {string} sampleListId - Sample List ID e.g. acc_tcga_all
     * @param {integer} entrezGeneId - Entrez Gene ID
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getMutationsInMolecularProfileBySampleListIdUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getMutationsInMolecularProfileBySampleListIdUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMutationsInMolecularProfileUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/mutations/fetch';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch mutations in a molecular profile
     * @method
     * @name CBioPortalAPI#fetchMutationsInMolecularProfileUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_mutations
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     * @param {} mutationFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMutationsInMolecularProfileUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/mutations/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters['mutationFilter'] !== undefined) {
                    body = parameters['mutationFilter'];
                }
                if (parameters['mutationFilter'] === undefined) {
                    reject(new Error('Missing required  parameter: mutationFilter'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch mutations in a molecular profile
     * @method
     * @name CBioPortalAPI#fetchMutationsInMolecularProfileUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_mutations
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     * @param {} mutationFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMutationsInMolecularProfileUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchMutationsInMolecularProfileUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMutationsInMultipleMolecularProfilesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/mutations/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch mutations in multiple molecular profiles by sample IDs
     * @method
     * @name CBioPortalAPI#fetchMutationsInMultipleMolecularProfilesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     * @param {} mutationMultipleStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMutationsInMultipleMolecularProfilesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/mutations/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters['mutationMultipleStudyFilter'] !== undefined) {
                    body = parameters['mutationMultipleStudyFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch mutations in multiple molecular profiles by sample IDs
     * @method
     * @name CBioPortalAPI#fetchMutationsInMultipleMolecularProfilesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     * @param {} mutationMultipleStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchMutationsInMultipleMolecularProfilesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchMutationsInMultipleMolecularProfilesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllPatientsUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/patients';
            if (parameters['keyword'] !== undefined) {
                queryParameters['keyword'] = parameters['keyword'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            queryParameters['sortBy'] = 'patientId';
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
    * Get all patients
    * @method
    * @name CBioPortalAPI#getAllPatientsUsingGET
         * @param {string} keyword - Search keyword that applies to ID of the patients
         * @param {string} projection - Level of detail of the response
         * @param {integer} pageSize - Page size of the result list
         * @param {integer} pageNumber - Page number of the result list
        
         * @param {string} direction - Direction of the sort
    */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllPatientsUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/patients';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters['keyword'] !== undefined) {
                    queryParameters['keyword'] = parameters['keyword'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                queryParameters['sortBy'] = 'patientId';
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
    * Get all patients
    * @method
    * @name CBioPortalAPI#getAllPatientsUsingGET
         * @param {string} keyword - Search keyword that applies to ID of the patients
         * @param {string} projection - Level of detail of the response
         * @param {integer} pageSize - Page size of the result list
         * @param {integer} pageNumber - Page number of the result list
        
         * @param {string} direction - Direction of the sort
    */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllPatientsUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllPatientsUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchPatientsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/patients/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     *
     * @method
     * @name CBioPortalAPI#fetchPatientsUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} patientFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchPatientsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/patients/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['patientFilter'] !== undefined) {
                    body = parameters['patientFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     *
     * @method
     * @name CBioPortalAPI#fetchPatientsUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} patientFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchPatientsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchPatientsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleListsUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/sample-lists';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all sample lists
     * @method
     * @name CBioPortalAPI#getAllSampleListsUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleListsUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/sample-lists';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all sample lists
     * @method
     * @name CBioPortalAPI#getAllSampleListsUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleListsUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllSampleListsUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchSampleListsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/sample-lists/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch sample lists by ID
     * @method
     * @name CBioPortalAPI#fetchSampleListsUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} sampleListIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchSampleListsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/sample-lists/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['sampleListIds'] !== undefined) {
                    body = parameters['sampleListIds'];
                }
                if (parameters['sampleListIds'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleListIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch sample lists by ID
     * @method
     * @name CBioPortalAPI#fetchSampleListsUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} sampleListIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchSampleListsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchSampleListsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getSampleListUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/sample-lists/{sampleListId}';
            path = path.replace('{sampleListId}', parameters['sampleListId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get sample list
     * @method
     * @name CBioPortalAPI#getSampleListUsingGET
     * @param {string} sampleListId - Sample List ID e.g. acc_tcga_all
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getSampleListUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/sample-lists/{sampleListId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{sampleListId}', parameters['sampleListId'] + '');
                if (parameters['sampleListId'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleListId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get sample list
     * @method
     * @name CBioPortalAPI#getSampleListUsingGET
     * @param {string} sampleListId - Sample List ID e.g. acc_tcga_all
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getSampleListUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getSampleListUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleIdsInSampleListUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/sample-lists/{sampleListId}/sample-ids';
            path = path.replace('{sampleListId}', parameters['sampleListId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all sample IDs in a sample list
     * @method
     * @name CBioPortalAPI#getAllSampleIdsInSampleListUsingGET
     * @param {string} sampleListId - Sample List ID e.g. acc_tcga_all
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleIdsInSampleListUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/sample-lists/{sampleListId}/sample-ids';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{sampleListId}', parameters['sampleListId'] + '');
                if (parameters['sampleListId'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleListId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all sample IDs in a sample list
     * @method
     * @name CBioPortalAPI#getAllSampleIdsInSampleListUsingGET
     * @param {string} sampleListId - Sample List ID e.g. acc_tcga_all
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleIdsInSampleListUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllSampleIdsInSampleListUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getSamplesByKeywordUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/samples';
            if (parameters['keyword'] !== undefined) {
                queryParameters['keyword'] = parameters['keyword'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all samples matching keyword
     * @method
     * @name CBioPortalAPI#getSamplesByKeywordUsingGET
     * @param {string} keyword - Search keyword that applies to the study ID
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getSamplesByKeywordUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/samples';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters['keyword'] !== undefined) {
                    queryParameters['keyword'] = parameters['keyword'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all samples matching keyword
     * @method
     * @name CBioPortalAPI#getSamplesByKeywordUsingGET
     * @param {string} keyword - Search keyword that applies to the study ID
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getSamplesByKeywordUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getSamplesByKeywordUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchSamplesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/samples/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch samples by ID
     * @method
     * @name CBioPortalAPI#fetchSamplesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} sampleFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchSamplesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/samples/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['sampleFilter'] !== undefined) {
                    body = parameters['sampleFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch samples by ID
     * @method
     * @name CBioPortalAPI#fetchSamplesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} sampleFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchSamplesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchSamplesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllStudiesUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies';
            if (parameters['keyword'] !== undefined) {
                queryParameters['keyword'] = parameters['keyword'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all studies
     * @method
     * @name CBioPortalAPI#getAllStudiesUsingGET
     * @param {string} keyword - Search keyword that applies to name and cancer type of the studies
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllStudiesUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters['keyword'] !== undefined) {
                    queryParameters['keyword'] = parameters['keyword'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all studies
     * @method
     * @name CBioPortalAPI#getAllStudiesUsingGET
     * @param {string} keyword - Search keyword that applies to name and cancer type of the studies
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllStudiesUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllStudiesUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchStudiesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch studies by IDs
     * @method
     * @name CBioPortalAPI#fetchStudiesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchStudiesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['studyIds'] !== undefined) {
                    body = parameters['studyIds'];
                }
                if (parameters['studyIds'] === undefined) {
                    reject(new Error('Missing required  parameter: studyIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch studies by IDs
     * @method
     * @name CBioPortalAPI#fetchStudiesUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchStudiesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchStudiesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getTagsForMultipleStudiesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/tags/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get the study tags by IDs
     * @method
     * @name CBioPortalAPI#getTagsForMultipleStudiesUsingPOST
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getTagsForMultipleStudiesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/tags/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['studyIds'] !== undefined) {
                    body = parameters['studyIds'];
                }
                if (parameters['studyIds'] === undefined) {
                    reject(new Error('Missing required  parameter: studyIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get the study tags by IDs
     * @method
     * @name CBioPortalAPI#getTagsForMultipleStudiesUsingPOST
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getTagsForMultipleStudiesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getTagsForMultipleStudiesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get a study
     * @method
     * @name CBioPortalAPI#getStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get a study
     * @method
     * @name CBioPortalAPI#getStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalAttributesInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/clinical-attributes';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all clinical attributes in the specified study
     * @method
     * @name CBioPortalAPI#getAllClinicalAttributesInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalAttributesInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/clinical-attributes';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all clinical attributes in the specified study
     * @method
     * @name CBioPortalAPI#getAllClinicalAttributesInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalAttributesInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllClinicalAttributesInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getClinicalAttributeInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/clinical-attributes/{clinicalAttributeId}';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{clinicalAttributeId}', parameters['clinicalAttributeId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get specified clinical attribute
     * @method
     * @name CBioPortalAPI#getClinicalAttributeInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} clinicalAttributeId - Clinical Attribute ID e.g. CANCER_TYPE
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getClinicalAttributeInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/clinical-attributes/{clinicalAttributeId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{clinicalAttributeId}', parameters['clinicalAttributeId'] + '');
                if (parameters['clinicalAttributeId'] === undefined) {
                    reject(new Error('Missing required  parameter: clinicalAttributeId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get specified clinical attribute
     * @method
     * @name CBioPortalAPI#getClinicalAttributeInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} clinicalAttributeId - Clinical Attribute ID e.g. CANCER_TYPE
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getClinicalAttributeInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getClinicalAttributeInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalDataInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/clinical-data';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['attributeId'] !== undefined) {
                queryParameters['attributeId'] = parameters['attributeId'];
            }
            if (parameters['clinicalDataType'] !== undefined) {
                queryParameters['clinicalDataType'] = parameters['clinicalDataType'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all clinical data in a study
     * @method
     * @name CBioPortalAPI#getAllClinicalDataInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} attributeId - Attribute ID e.g. CANCER_TYPE
     * @param {string} clinicalDataType - Type of the clinical data
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalDataInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/clinical-data';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['attributeId'] !== undefined) {
                    queryParameters['attributeId'] = parameters['attributeId'];
                }
                if (parameters['clinicalDataType'] !== undefined) {
                    queryParameters['clinicalDataType'] = parameters['clinicalDataType'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all clinical data in a study
     * @method
     * @name CBioPortalAPI#getAllClinicalDataInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} attributeId - Attribute ID e.g. CANCER_TYPE
     * @param {string} clinicalDataType - Type of the clinical data
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalDataInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllClinicalDataInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "fetchAllClinicalDataInStudyUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/clinical-data/fetch';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['clinicalDataType'] !== undefined) {
                queryParameters['clinicalDataType'] = parameters['clinicalDataType'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch clinical data by patient IDs or sample IDs (specific study)
     * @method
     * @name CBioPortalAPI#fetchAllClinicalDataInStudyUsingPOST
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} clinicalDataType - Type of the clinical data
     * @param {string} projection - Level of detail of the response
     * @param {} clinicalDataSingleStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchAllClinicalDataInStudyUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/clinical-data/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['clinicalDataType'] !== undefined) {
                    queryParameters['clinicalDataType'] = parameters['clinicalDataType'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['clinicalDataSingleStudyFilter'] !== undefined) {
                    body = parameters['clinicalDataSingleStudyFilter'];
                }
                if (parameters['clinicalDataSingleStudyFilter'] === undefined) {
                    reject(new Error('Missing required  parameter: clinicalDataSingleStudyFilter'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch clinical data by patient IDs or sample IDs (specific study)
     * @method
     * @name CBioPortalAPI#fetchAllClinicalDataInStudyUsingPOST
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} clinicalDataType - Type of the clinical data
     * @param {string} projection - Level of detail of the response
     * @param {} clinicalDataSingleStudyFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "fetchAllClinicalDataInStudyUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchAllClinicalDataInStudyUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllMolecularProfilesInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/molecular-profiles';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all molecular profiles in a study
     * @method
     * @name CBioPortalAPI#getAllMolecularProfilesInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllMolecularProfilesInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/molecular-profiles';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all molecular profiles in a study
     * @method
     * @name CBioPortalAPI#getAllMolecularProfilesInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllMolecularProfilesInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllMolecularProfilesInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllPatientsInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/patients';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            queryParameters['sortBy'] = 'patientId';
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
    * Get all patients in a study
    * @method
    * @name CBioPortalAPI#getAllPatientsInStudyUsingGET
         * @param {string} studyId - Study ID e.g. acc_tcga
         * @param {string} projection - Level of detail of the response
         * @param {integer} pageSize - Page size of the result list
         * @param {integer} pageNumber - Page number of the result list
        
         * @param {string} direction - Direction of the sort
    */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllPatientsInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/patients';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                queryParameters['sortBy'] = 'patientId';
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
    * Get all patients in a study
    * @method
    * @name CBioPortalAPI#getAllPatientsInStudyUsingGET
         * @param {string} studyId - Study ID e.g. acc_tcga
         * @param {string} projection - Level of detail of the response
         * @param {integer} pageSize - Page size of the result list
         * @param {integer} pageNumber - Page number of the result list
        
         * @param {string} direction - Direction of the sort
    */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllPatientsInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllPatientsInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getPatientInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/patients/{patientId}';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{patientId}', parameters['patientId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get a patient in a study
     * @method
     * @name CBioPortalAPI#getPatientInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} patientId - Patient ID e.g. TCGA-OR-A5J2
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getPatientInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/patients/{patientId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{patientId}', parameters['patientId'] + '');
                if (parameters['patientId'] === undefined) {
                    reject(new Error('Missing required  parameter: patientId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get a patient in a study
     * @method
     * @name CBioPortalAPI#getPatientInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} patientId - Patient ID e.g. TCGA-OR-A5J2
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getPatientInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getPatientInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalDataOfPatientInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/patients/{patientId}/clinical-data';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{patientId}', parameters['patientId'] + '');
            if (parameters['attributeId'] !== undefined) {
                queryParameters['attributeId'] = parameters['attributeId'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all clinical data of a patient in a study
     * @method
     * @name CBioPortalAPI#getAllClinicalDataOfPatientInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} patientId - Patient ID e.g. TCGA-OR-A5J2
     * @param {string} attributeId - Attribute ID e.g. AGE
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalDataOfPatientInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/patients/{patientId}/clinical-data';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{patientId}', parameters['patientId'] + '');
                if (parameters['patientId'] === undefined) {
                    reject(new Error('Missing required  parameter: patientId'));
                    return;
                }
                if (parameters['attributeId'] !== undefined) {
                    queryParameters['attributeId'] = parameters['attributeId'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all clinical data of a patient in a study
     * @method
     * @name CBioPortalAPI#getAllClinicalDataOfPatientInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} patientId - Patient ID e.g. TCGA-OR-A5J2
     * @param {string} attributeId - Attribute ID e.g. AGE
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalDataOfPatientInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllClinicalDataOfPatientInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSamplesOfPatientInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/patients/{patientId}/samples';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{patientId}', parameters['patientId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all samples of a patient in a study
     * @method
     * @name CBioPortalAPI#getAllSamplesOfPatientInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} patientId - Patient ID e.g. TCGA-OR-A5J2
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSamplesOfPatientInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/patients/{patientId}/samples';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{patientId}', parameters['patientId'] + '');
                if (parameters['patientId'] === undefined) {
                    reject(new Error('Missing required  parameter: patientId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all samples of a patient in a study
     * @method
     * @name CBioPortalAPI#getAllSamplesOfPatientInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} patientId - Patient ID e.g. TCGA-OR-A5J2
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSamplesOfPatientInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllSamplesOfPatientInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleListsInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/sample-lists';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all sample lists in a study
     * @method
     * @name CBioPortalAPI#getAllSampleListsInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleListsInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/sample-lists';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all sample lists in a study
     * @method
     * @name CBioPortalAPI#getAllSampleListsInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleListsInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllSampleListsInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSamplesInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/samples';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all samples in a study
     * @method
     * @name CBioPortalAPI#getAllSamplesInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSamplesInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/samples';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all samples in a study
     * @method
     * @name CBioPortalAPI#getAllSamplesInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSamplesInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllSamplesInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getSampleInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/samples/{sampleId}';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{sampleId}', parameters['sampleId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get a sample in a study
     * @method
     * @name CBioPortalAPI#getSampleInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} sampleId - Sample ID e.g. TCGA-OR-A5J2-01
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getSampleInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/samples/{sampleId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{sampleId}', parameters['sampleId'] + '');
                if (parameters['sampleId'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get a sample in a study
     * @method
     * @name CBioPortalAPI#getSampleInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} sampleId - Sample ID e.g. TCGA-OR-A5J2-01
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getSampleInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getSampleInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalDataOfSampleInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/samples/{sampleId}/clinical-data';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{sampleId}', parameters['sampleId'] + '');
            if (parameters['attributeId'] !== undefined) {
                queryParameters['attributeId'] = parameters['attributeId'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all clinical data of a sample in a study
     * @method
     * @name CBioPortalAPI#getAllClinicalDataOfSampleInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} sampleId - Sample ID e.g. TCGA-OR-A5J2-01
     * @param {string} attributeId - Attribute ID e.g. CANCER_TYPE
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalDataOfSampleInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/samples/{sampleId}/clinical-data';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{sampleId}', parameters['sampleId'] + '');
                if (parameters['sampleId'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleId'));
                    return;
                }
                if (parameters['attributeId'] !== undefined) {
                    queryParameters['attributeId'] = parameters['attributeId'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all clinical data of a sample in a study
     * @method
     * @name CBioPortalAPI#getAllClinicalDataOfSampleInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} sampleId - Sample ID e.g. TCGA-OR-A5J2-01
     * @param {string} attributeId - Attribute ID e.g. CANCER_TYPE
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllClinicalDataOfSampleInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllClinicalDataOfSampleInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getCopyNumberSegmentsInSampleInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/samples/{sampleId}/copy-number-segments';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{sampleId}', parameters['sampleId'] + '');
            if (parameters['chromosome'] !== undefined) {
                queryParameters['chromosome'] = parameters['chromosome'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get copy number segments in a sample in a study
     * @method
     * @name CBioPortalAPI#getCopyNumberSegmentsInSampleInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} sampleId - Sample ID e.g. TCGA-OR-A5J2-01
     * @param {string} chromosome - Chromosome
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getCopyNumberSegmentsInSampleInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/samples/{sampleId}/copy-number-segments';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{sampleId}', parameters['sampleId'] + '');
                if (parameters['sampleId'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleId'));
                    return;
                }
                if (parameters['chromosome'] !== undefined) {
                    queryParameters['chromosome'] = parameters['chromosome'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get copy number segments in a sample in a study
     * @method
     * @name CBioPortalAPI#getCopyNumberSegmentsInSampleInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} sampleId - Sample ID e.g. TCGA-OR-A5J2-01
     * @param {string} chromosome - Chromosome
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getCopyNumberSegmentsInSampleInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getCopyNumberSegmentsInSampleInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getTagsUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/tags';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get the tags of a study
     * @method
     * @name CBioPortalAPI#getTagsUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getTagsUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/tags';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get the tags of a study
     * @method
     * @name CBioPortalAPI#getTagsUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getTagsUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getTagsUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getContainsTreatmentDataUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/treatments/display-patient';
            if (parameters['tier'] !== undefined) {
                queryParameters['tier'] = parameters['tier'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Should patient level treatments be displayed
     * @method
     * @name CBioPortalAPI#getContainsTreatmentDataUsingPOST
     * @param {string} tier - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getContainsTreatmentDataUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/treatments/display-patient';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['tier'] !== undefined) {
                    queryParameters['tier'] = parameters['tier'];
                }
                if (parameters['studyIds'] !== undefined) {
                    body = parameters['studyIds'];
                }
                if (parameters['studyIds'] === undefined) {
                    reject(new Error('Missing required  parameter: studyIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Should patient level treatments be displayed
     * @method
     * @name CBioPortalAPI#getContainsTreatmentDataUsingPOST
     * @param {string} tier - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getContainsTreatmentDataUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getContainsTreatmentDataUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getContainsSampleTreatmentDataUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/treatments/display-sample';
            if (parameters['tier'] !== undefined) {
                queryParameters['tier'] = parameters['tier'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Should sample level treatments be displayed
     * @method
     * @name CBioPortalAPI#getContainsSampleTreatmentDataUsingPOST
     * @param {string} tier - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getContainsSampleTreatmentDataUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/treatments/display-sample';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['tier'] !== undefined) {
                    queryParameters['tier'] = parameters['tier'];
                }
                if (parameters['studyIds'] !== undefined) {
                    body = parameters['studyIds'];
                }
                if (parameters['studyIds'] === undefined) {
                    reject(new Error('Missing required  parameter: studyIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Should sample level treatments be displayed
     * @method
     * @name CBioPortalAPI#getContainsSampleTreatmentDataUsingPOST
     * @param {string} tier - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getContainsSampleTreatmentDataUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getContainsSampleTreatmentDataUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllPatientTreatmentsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/treatments/patient';
            if (parameters['tier'] !== undefined) {
                queryParameters['tier'] = parameters['tier'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all patient level treatments
     * @method
     * @name CBioPortalAPI#getAllPatientTreatmentsUsingPOST
     * @param {string} tier - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllPatientTreatmentsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/treatments/patient';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['tier'] !== undefined) {
                    queryParameters['tier'] = parameters['tier'];
                }
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all patient level treatments
     * @method
     * @name CBioPortalAPI#getAllPatientTreatmentsUsingPOST
     * @param {string} tier - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllPatientTreatmentsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllPatientTreatmentsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleTreatmentsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/treatments/sample';
            if (parameters['tier'] !== undefined) {
                queryParameters['tier'] = parameters['tier'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all sample level treatments
     * @method
     * @name CBioPortalAPI#getAllSampleTreatmentsUsingPOST
     * @param {string} tier - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleTreatmentsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/treatments/sample';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['tier'] !== undefined) {
                    queryParameters['tier'] = parameters['tier'];
                }
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all sample level treatments
     * @method
     * @name CBioPortalAPI#getAllSampleTreatmentsUsingPOST
     * @param {string} tier - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPI.prototype, "getAllSampleTreatmentsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllSampleTreatmentsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    return CBioPortalAPI;
}());

/**
 * A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
 * @class CBioPortalAPIInternal
 * @param {(string)} [domainOrOptions] - The project domain.
 */
var CBioPortalAPIInternal = /** @class */ (function () {
    function CBioPortalAPIInternal(domain) {
        Object.defineProperty(this, "domain", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "errorHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        if (domain) {
            this.domain = domain;
        }
    }
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getDomain", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.domain;
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "addErrorHandler", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (handler) {
            this.errorHandlers.push(handler);
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "request", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (method, url, body, headers, queryParameters, form, reject, resolve, errorHandlers) {
            var req = new request.Request(method, url)
                .query(queryParameters);
            Object.keys(headers).forEach(function (key) {
                req.set(key, headers[key]);
            });
            if (body) {
                req.send(body);
            }
            if (typeof (body) === 'object' && !(body.constructor.name === 'Buffer')) {
                req.set('Content-Type', 'application/json');
            }
            if (Object.keys(form).length > 0) {
                req.type('form');
                req.send(form);
            }
            req.end(function (error, response) {
                if (error || !response.ok) {
                    reject(error);
                    errorHandlers.forEach(function (handler) { return handler(error); });
                }
                else {
                    resolve(response);
                }
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchAlterationEnrichmentsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/alteration-enrichments/fetch';
            if (parameters['enrichmentType'] !== undefined) {
                queryParameters['enrichmentType'] = parameters['enrichmentType'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch alteration enrichments in molecular profiles
     * @method
     * @name CBioPortalAPIInternal#fetchAlterationEnrichmentsUsingPOST
     * @param {string} enrichmentType - Type of the enrichment e.g. SAMPLE or PATIENT
     * @param {} molecularProfileCasesGroupAndAlterationTypeFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchAlterationEnrichmentsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/alteration-enrichments/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['enrichmentType'] !== undefined) {
                    queryParameters['enrichmentType'] = parameters['enrichmentType'];
                }
                if (parameters['molecularProfileCasesGroupAndAlterationTypeFilter'] !== undefined) {
                    body = parameters['molecularProfileCasesGroupAndAlterationTypeFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch alteration enrichments in molecular profiles
     * @method
     * @name CBioPortalAPIInternal#fetchAlterationEnrichmentsUsingPOST
     * @param {string} enrichmentType - Type of the enrichment e.g. SAMPLE or PATIENT
     * @param {} molecularProfileCasesGroupAndAlterationTypeFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchAlterationEnrichmentsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchAlterationEnrichmentsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "clearAllCachesUsingDELETEURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/cache';
            if (parameters['springManagedCache'] !== undefined) {
                queryParameters['springManagedCache'] = parameters['springManagedCache'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Clear and reinitialize caches
     * @method
     * @name CBioPortalAPIInternal#clearAllCachesUsingDELETE
     * @param {string} xApiKey - Secret API key passed in HTTP header. The key is configured in application.properties of the portal instance.
     * @param {boolean} springManagedCache - Clear Spring-managed caches
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "clearAllCachesUsingDELETEWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/cache';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'text/plain';
                if (parameters['xApiKey'] !== undefined) {
                    headers['X-API-KEY'] = parameters['xApiKey'];
                }
                if (parameters['xApiKey'] === undefined) {
                    reject(new Error('Missing required  parameter: xApiKey'));
                    return;
                }
                if (parameters['springManagedCache'] !== undefined) {
                    queryParameters['springManagedCache'] = parameters['springManagedCache'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Clear and reinitialize caches
     * @method
     * @name CBioPortalAPIInternal#clearAllCachesUsingDELETE
     * @param {string} xApiKey - Secret API key passed in HTTP header. The key is configured in application.properties of the portal instance.
     * @param {boolean} springManagedCache - Clear Spring-managed caches
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "clearAllCachesUsingDELETE", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.clearAllCachesUsingDELETEWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getClinicalAttributeCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-attributes/counts/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get counts for clinical attributes according to their data availability for selected samples/patients
     * @method
     * @name CBioPortalAPIInternal#getClinicalAttributeCountsUsingPOST
     * @param {} clinicalAttributeCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getClinicalAttributeCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-attributes/counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['clinicalAttributeCountFilter'] !== undefined) {
                    body = parameters['clinicalAttributeCountFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get counts for clinical attributes according to their data availability for selected samples/patients
     * @method
     * @name CBioPortalAPIInternal#getClinicalAttributeCountsUsingPOST
     * @param {} clinicalAttributeCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getClinicalAttributeCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getClinicalAttributeCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataBinCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-data-bin-counts/fetch';
            if (parameters['dataBinMethod'] !== undefined) {
                queryParameters['dataBinMethod'] = parameters['dataBinMethod'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch clinical data bin counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalDataBinCountsUsingPOST
     * @param {string} dataBinMethod - Method for data binning
     * @param {} clinicalDataBinCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataBinCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-data-bin-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['dataBinMethod'] !== undefined) {
                    queryParameters['dataBinMethod'] = parameters['dataBinMethod'];
                }
                if (parameters['clinicalDataBinCountFilter'] !== undefined) {
                    body = parameters['clinicalDataBinCountFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch clinical data bin counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalDataBinCountsUsingPOST
     * @param {string} dataBinMethod - Method for data binning
     * @param {} clinicalDataBinCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataBinCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchClinicalDataBinCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-data-counts/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch clinical data counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalDataCountsUsingPOST
     * @param {} clinicalDataCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-data-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['clinicalDataCountFilter'] !== undefined) {
                    body = parameters['clinicalDataCountFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch clinical data counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalDataCountsUsingPOST
     * @param {} clinicalDataCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchClinicalDataCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataDensityPlotUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-data-density-plot/fetch';
            if (parameters['xAxisAttributeId'] !== undefined) {
                queryParameters['xAxisAttributeId'] = parameters['xAxisAttributeId'];
            }
            if (parameters['xAxisBinCount'] !== undefined) {
                queryParameters['xAxisBinCount'] = parameters['xAxisBinCount'];
            }
            if (parameters['xAxisStart'] !== undefined) {
                queryParameters['xAxisStart'] = parameters['xAxisStart'];
            }
            if (parameters['xAxisEnd'] !== undefined) {
                queryParameters['xAxisEnd'] = parameters['xAxisEnd'];
            }
            if (parameters['yAxisAttributeId'] !== undefined) {
                queryParameters['yAxisAttributeId'] = parameters['yAxisAttributeId'];
            }
            if (parameters['yAxisBinCount'] !== undefined) {
                queryParameters['yAxisBinCount'] = parameters['yAxisBinCount'];
            }
            if (parameters['yAxisStart'] !== undefined) {
                queryParameters['yAxisStart'] = parameters['yAxisStart'];
            }
            if (parameters['yAxisEnd'] !== undefined) {
                queryParameters['yAxisEnd'] = parameters['yAxisEnd'];
            }
            if (parameters['xAxisLogScale'] !== undefined) {
                queryParameters['xAxisLogScale'] = parameters['xAxisLogScale'];
            }
            if (parameters['yAxisLogScale'] !== undefined) {
                queryParameters['yAxisLogScale'] = parameters['yAxisLogScale'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch clinical data density plot bins by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalDataDensityPlotUsingPOST
     * @param {string} xAxisAttributeId - Clinical Attribute ID of the X axis
     * @param {integer} xAxisBinCount - Number of the bins in X axis
     * @param {number} xAxisStart - Starting point of the X axis, if different than smallest value
     * @param {number} xAxisEnd - Starting point of the X axis, if different than largest value
     * @param {string} yAxisAttributeId - Clinical Attribute ID of the Y axis
     * @param {integer} yAxisBinCount - Number of the bins in Y axis
     * @param {number} yAxisStart - Starting point of the Y axis, if different than smallest value
     * @param {number} yAxisEnd - Starting point of the Y axis, if different than largest value
     * @param {boolean} xAxisLogScale - Use log scale for X axis
     * @param {boolean} yAxisLogScale - Use log scale for Y axis
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataDensityPlotUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-data-density-plot/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['xAxisAttributeId'] !== undefined) {
                    queryParameters['xAxisAttributeId'] = parameters['xAxisAttributeId'];
                }
                if (parameters['xAxisAttributeId'] === undefined) {
                    reject(new Error('Missing required  parameter: xAxisAttributeId'));
                    return;
                }
                if (parameters['xAxisBinCount'] !== undefined) {
                    queryParameters['xAxisBinCount'] = parameters['xAxisBinCount'];
                }
                if (parameters['xAxisStart'] !== undefined) {
                    queryParameters['xAxisStart'] = parameters['xAxisStart'];
                }
                if (parameters['xAxisEnd'] !== undefined) {
                    queryParameters['xAxisEnd'] = parameters['xAxisEnd'];
                }
                if (parameters['yAxisAttributeId'] !== undefined) {
                    queryParameters['yAxisAttributeId'] = parameters['yAxisAttributeId'];
                }
                if (parameters['yAxisAttributeId'] === undefined) {
                    reject(new Error('Missing required  parameter: yAxisAttributeId'));
                    return;
                }
                if (parameters['yAxisBinCount'] !== undefined) {
                    queryParameters['yAxisBinCount'] = parameters['yAxisBinCount'];
                }
                if (parameters['yAxisStart'] !== undefined) {
                    queryParameters['yAxisStart'] = parameters['yAxisStart'];
                }
                if (parameters['yAxisEnd'] !== undefined) {
                    queryParameters['yAxisEnd'] = parameters['yAxisEnd'];
                }
                if (parameters['xAxisLogScale'] !== undefined) {
                    queryParameters['xAxisLogScale'] = parameters['xAxisLogScale'];
                }
                if (parameters['yAxisLogScale'] !== undefined) {
                    queryParameters['yAxisLogScale'] = parameters['yAxisLogScale'];
                }
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch clinical data density plot bins by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalDataDensityPlotUsingPOST
     * @param {string} xAxisAttributeId - Clinical Attribute ID of the X axis
     * @param {integer} xAxisBinCount - Number of the bins in X axis
     * @param {number} xAxisStart - Starting point of the X axis, if different than smallest value
     * @param {number} xAxisEnd - Starting point of the X axis, if different than largest value
     * @param {string} yAxisAttributeId - Clinical Attribute ID of the Y axis
     * @param {integer} yAxisBinCount - Number of the bins in Y axis
     * @param {number} yAxisStart - Starting point of the Y axis, if different than smallest value
     * @param {number} yAxisEnd - Starting point of the Y axis, if different than largest value
     * @param {boolean} xAxisLogScale - Use log scale for X axis
     * @param {boolean} yAxisLogScale - Use log scale for Y axis
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataDensityPlotUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchClinicalDataDensityPlotUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalEnrichmentsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-data-enrichments/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch clinical data enrichments for the sample groups
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalEnrichmentsUsingPOST
     * @param {} groupFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalEnrichmentsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-data-enrichments/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['groupFilter'] !== undefined) {
                    body = parameters['groupFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch clinical data enrichments for the sample groups
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalEnrichmentsUsingPOST
     * @param {} groupFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalEnrichmentsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchClinicalEnrichmentsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataClinicalTableUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-data-table/fetch';
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['searchTerm'] !== undefined) {
                queryParameters['searchTerm'] = parameters['searchTerm'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch clinical data for the Clinical Tab of Study View
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalDataClinicalTableUsingPOST
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} searchTerm - Search term to filter sample rows. Samples are returned with a partial match to the search term for any sample clinical attribute.
     * @param {string} sortBy - sampleId, patientId, or the ATTR_ID to sorted by
     * @param {string} direction - Direction of the sort
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataClinicalTableUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-data-table/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['searchTerm'] !== undefined) {
                    queryParameters['searchTerm'] = parameters['searchTerm'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch clinical data for the Clinical Tab of Study View
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalDataClinicalTableUsingPOST
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} searchTerm - Search term to filter sample rows. Samples are returned with a partial match to the search term for any sample clinical attribute.
     * @param {string} sortBy - sampleId, patientId, or the ATTR_ID to sorted by
     * @param {string} direction - Direction of the sort
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataClinicalTableUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchClinicalDataClinicalTableUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataViolinPlotsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-data-violin-plots/fetch';
            if (parameters['categoricalAttributeId'] !== undefined) {
                queryParameters['categoricalAttributeId'] = parameters['categoricalAttributeId'];
            }
            if (parameters['numericalAttributeId'] !== undefined) {
                queryParameters['numericalAttributeId'] = parameters['numericalAttributeId'];
            }
            if (parameters['axisStart'] !== undefined) {
                queryParameters['axisStart'] = parameters['axisStart'];
            }
            if (parameters['axisEnd'] !== undefined) {
                queryParameters['axisEnd'] = parameters['axisEnd'];
            }
            if (parameters['numCurvePoints'] !== undefined) {
                queryParameters['numCurvePoints'] = parameters['numCurvePoints'];
            }
            if (parameters['logScale'] !== undefined) {
                queryParameters['logScale'] = parameters['logScale'];
            }
            if (parameters['sigmaMultiplier'] !== undefined) {
                queryParameters['sigmaMultiplier'] = parameters['sigmaMultiplier'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch violin plot curves per categorical clinical data value, filtered by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalDataViolinPlotsUsingPOST
     * @param {string} categoricalAttributeId - Clinical Attribute ID of the categorical attribute
     * @param {string} numericalAttributeId - Clinical Attribute ID of the numerical attribute
     * @param {number} axisStart - Starting point of the violin plot axis, if different than smallest value
     * @param {number} axisEnd - Ending point  of the violin plot axis, if different than largest value
     * @param {number} numCurvePoints - Number of points in the curve
     * @param {boolean} logScale - Use log scale for the numerical attribute
     * @param {number} sigmaMultiplier - Sigma stepsize multiplier
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataViolinPlotsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-data-violin-plots/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['categoricalAttributeId'] !== undefined) {
                    queryParameters['categoricalAttributeId'] = parameters['categoricalAttributeId'];
                }
                if (parameters['categoricalAttributeId'] === undefined) {
                    reject(new Error('Missing required  parameter: categoricalAttributeId'));
                    return;
                }
                if (parameters['numericalAttributeId'] !== undefined) {
                    queryParameters['numericalAttributeId'] = parameters['numericalAttributeId'];
                }
                if (parameters['numericalAttributeId'] === undefined) {
                    reject(new Error('Missing required  parameter: numericalAttributeId'));
                    return;
                }
                if (parameters['axisStart'] !== undefined) {
                    queryParameters['axisStart'] = parameters['axisStart'];
                }
                if (parameters['axisEnd'] !== undefined) {
                    queryParameters['axisEnd'] = parameters['axisEnd'];
                }
                if (parameters['numCurvePoints'] !== undefined) {
                    queryParameters['numCurvePoints'] = parameters['numCurvePoints'];
                }
                if (parameters['logScale'] !== undefined) {
                    queryParameters['logScale'] = parameters['logScale'];
                }
                if (parameters['sigmaMultiplier'] !== undefined) {
                    queryParameters['sigmaMultiplier'] = parameters['sigmaMultiplier'];
                }
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch violin plot curves per categorical clinical data value, filtered by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchClinicalDataViolinPlotsUsingPOST
     * @param {string} categoricalAttributeId - Clinical Attribute ID of the categorical attribute
     * @param {string} numericalAttributeId - Clinical Attribute ID of the numerical attribute
     * @param {number} axisStart - Starting point of the violin plot axis, if different than smallest value
     * @param {number} axisEnd - Ending point  of the violin plot axis, if different than largest value
     * @param {number} numCurvePoints - Number of points in the curve
     * @param {boolean} logScale - Use log scale for the numerical attribute
     * @param {number} sigmaMultiplier - Sigma stepsize multiplier
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchClinicalDataViolinPlotsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchClinicalDataViolinPlotsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getClinicalEventTypeCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/clinical-event-type-counts/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get Counts of Clinical Event Types by Study View Filter
     * @method
     * @name CBioPortalAPIInternal#getClinicalEventTypeCountsUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getClinicalEventTypeCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/clinical-event-type-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get Counts of Clinical Event Types by Study View Filter
     * @method
     * @name CBioPortalAPIInternal#getClinicalEventTypeCountsUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getClinicalEventTypeCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getClinicalEventTypeCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCNAGenesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/cna-genes/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch CNA genes by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchCNAGenesUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCNAGenesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/cna-genes/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch CNA genes by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchCNAGenesUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCNAGenesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchCNAGenesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCosmicCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/cosmic-counts/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get counts within the COSMIC database by keywords
     * @method
     * @name CBioPortalAPIInternal#fetchCosmicCountsUsingPOST
     * @param {} keywords - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCosmicCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/cosmic-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['keywords'] !== undefined) {
                    body = parameters['keywords'];
                }
                if (parameters['keywords'] === undefined) {
                    reject(new Error('Missing required  parameter: keywords'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get counts within the COSMIC database by keywords
     * @method
     * @name CBioPortalAPIInternal#fetchCosmicCountsUsingPOST
     * @param {} keywords - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCosmicCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchCosmicCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCustomDataBinCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/custom-data-bin-counts/fetch';
            if (parameters['dataBinMethod'] !== undefined) {
                queryParameters['dataBinMethod'] = parameters['dataBinMethod'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch custom data bin counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchCustomDataBinCountsUsingPOST
     * @param {string} dataBinMethod - Method for data binning
     * @param {} clinicalDataBinCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCustomDataBinCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/custom-data-bin-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['dataBinMethod'] !== undefined) {
                    queryParameters['dataBinMethod'] = parameters['dataBinMethod'];
                }
                if (parameters['clinicalDataBinCountFilter'] !== undefined) {
                    body = parameters['clinicalDataBinCountFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch custom data bin counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchCustomDataBinCountsUsingPOST
     * @param {string} dataBinMethod - Method for data binning
     * @param {} clinicalDataBinCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCustomDataBinCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchCustomDataBinCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCustomDataCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/custom-data-counts/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch custom data counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchCustomDataCountsUsingPOST
     * @param {} clinicalDataCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCustomDataCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/custom-data-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['clinicalDataCountFilter'] !== undefined) {
                    body = parameters['clinicalDataCountFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch custom data counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchCustomDataCountsUsingPOST
     * @param {} clinicalDataCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCustomDataCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchCustomDataCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchAlterationDriverAnnotationReportUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/custom-driver-annotation-report/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Return availability of custom driver annotations for molecular profiles
     * @method
     * @name CBioPortalAPIInternal#fetchAlterationDriverAnnotationReportUsingPOST
     * @param {} molecularProfileIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchAlterationDriverAnnotationReportUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/custom-driver-annotation-report/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['molecularProfileIds'] !== undefined) {
                    body = parameters['molecularProfileIds'];
                }
                if (parameters['molecularProfileIds'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Return availability of custom driver annotations for molecular profiles
     * @method
     * @name CBioPortalAPIInternal#fetchAlterationDriverAnnotationReportUsingPOST
     * @param {} molecularProfileIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchAlterationDriverAnnotationReportUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchAlterationDriverAnnotationReportUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "downloadDataAccessTokenUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/data-access-token';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Create a new data access token
     * @method
     * @name CBioPortalAPIInternal#downloadDataAccessTokenUsingGET
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "downloadDataAccessTokenUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/data-access-token';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/octet-stream';
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Create a new data access token
     * @method
     * @name CBioPortalAPIInternal#downloadDataAccessTokenUsingGET
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "downloadDataAccessTokenUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.downloadDataAccessTokenUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "downloadOAuth2DataAccessTokenUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/data-access-token/oauth2';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     *
     * @method
     * @name CBioPortalAPIInternal#downloadOAuth2DataAccessTokenUsingGET
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "downloadOAuth2DataAccessTokenUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/data-access-token/oauth2';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/octet-stream';
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     *
     * @method
     * @name CBioPortalAPIInternal#downloadOAuth2DataAccessTokenUsingGET
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "downloadOAuth2DataAccessTokenUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.downloadOAuth2DataAccessTokenUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "revokeAllDataAccessTokensUsingDELETEURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/data-access-tokens';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Delete all data access tokens
     * @method
     * @name CBioPortalAPIInternal#revokeAllDataAccessTokensUsingDELETE
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "revokeAllDataAccessTokensUsingDELETEWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/data-access-tokens';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Delete all data access tokens
     * @method
     * @name CBioPortalAPIInternal#revokeAllDataAccessTokensUsingDELETE
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "revokeAllDataAccessTokensUsingDELETE", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.revokeAllDataAccessTokensUsingDELETEWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllDataAccessTokensUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/data-access-tokens';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Retrieve all data access tokens
     * @method
     * @name CBioPortalAPIInternal#getAllDataAccessTokensUsingGET
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllDataAccessTokensUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/data-access-tokens';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/octet-stream';
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Retrieve all data access tokens
     * @method
     * @name CBioPortalAPIInternal#getAllDataAccessTokensUsingGET
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllDataAccessTokensUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllDataAccessTokensUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "createDataAccessTokenUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/data-access-tokens';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all data access tokens
     * @method
     * @name CBioPortalAPIInternal#createDataAccessTokenUsingPOST
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "createDataAccessTokenUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/data-access-tokens';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all data access tokens
     * @method
     * @name CBioPortalAPIInternal#createDataAccessTokenUsingPOST
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "createDataAccessTokenUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.createDataAccessTokenUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "revokeDataAccessTokenUsingDELETEURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/data-access-tokens/{token}';
            path = path.replace('{token}', parameters['token'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Delete a data access token
     * @method
     * @name CBioPortalAPIInternal#revokeDataAccessTokenUsingDELETE
     * @param {string} token - token
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "revokeDataAccessTokenUsingDELETEWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/data-access-tokens/{token}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                path = path.replace('{token}', parameters['token'] + '');
                if (parameters['token'] === undefined) {
                    reject(new Error('Missing required  parameter: token'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Delete a data access token
     * @method
     * @name CBioPortalAPIInternal#revokeDataAccessTokenUsingDELETE
     * @param {string} token - token
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "revokeDataAccessTokenUsingDELETE", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.revokeDataAccessTokenUsingDELETEWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getDataAccessTokenUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/data-access-tokens/{token}';
            path = path.replace('{token}', parameters['token'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Retrieve an existing data access token
     * @method
     * @name CBioPortalAPIInternal#getDataAccessTokenUsingGET
     * @param {string} token - token
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getDataAccessTokenUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/data-access-tokens/{token}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/octet-stream';
                path = path.replace('{token}', parameters['token'] + '');
                if (parameters['token'] === undefined) {
                    reject(new Error('Missing required  parameter: token'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Retrieve an existing data access token
     * @method
     * @name CBioPortalAPIInternal#getDataAccessTokenUsingGET
     * @param {string} token - token
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getDataAccessTokenUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getDataAccessTokenUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenomicEnrichmentsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/expression-enrichments/fetch';
            if (parameters['enrichmentType'] !== undefined) {
                queryParameters['enrichmentType'] = parameters['enrichmentType'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch genomic enrichments in a molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchGenomicEnrichmentsUsingPOST
     * @param {string} enrichmentType - Type of the enrichment e.g. SAMPLE or PATIENT
     * @param {} groupsContainingSampleAndMolecularProfileIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenomicEnrichmentsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/expression-enrichments/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['enrichmentType'] !== undefined) {
                    queryParameters['enrichmentType'] = parameters['enrichmentType'];
                }
                if (parameters['groupsContainingSampleAndMolecularProfileIdentifiers'] !== undefined) {
                    body = parameters['groupsContainingSampleAndMolecularProfileIdentifiers'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch genomic enrichments in a molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchGenomicEnrichmentsUsingPOST
     * @param {string} enrichmentType - Type of the enrichment e.g. SAMPLE or PATIENT
     * @param {} groupsContainingSampleAndMolecularProfileIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenomicEnrichmentsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenomicEnrichmentsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchFilteredSamplesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/filtered-samples/fetch';
            if (parameters['negateFilters'] !== undefined) {
                queryParameters['negateFilters'] = parameters['negateFilters'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch sample IDs by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchFilteredSamplesUsingPOST
     * @param {boolean} negateFilters - Whether to negate the study view filters
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchFilteredSamplesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/filtered-samples/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['negateFilters'] !== undefined) {
                    queryParameters['negateFilters'] = parameters['negateFilters'];
                }
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch sample IDs by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchFilteredSamplesUsingPOST
     * @param {boolean} negateFilters - Whether to negate the study view filters
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchFilteredSamplesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchFilteredSamplesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayBinaryDataEnrichmentInMultipleMolecularProfilesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic-assay-binary-enrichments/fetch';
            if (parameters['enrichmentType'] !== undefined) {
                queryParameters['enrichmentType'] = parameters['enrichmentType'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch generic assay binary data enrichments in a molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchGenericAssayBinaryDataEnrichmentInMultipleMolecularProfilesUsingPOST
     * @param {string} enrichmentType - Type of the enrichment e.g. SAMPLE or PATIENT
     * @param {} groupsContainingSampleAndMolecularProfileIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayBinaryDataEnrichmentInMultipleMolecularProfilesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic-assay-binary-enrichments/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['enrichmentType'] !== undefined) {
                    queryParameters['enrichmentType'] = parameters['enrichmentType'];
                }
                if (parameters['groupsContainingSampleAndMolecularProfileIdentifiers'] !== undefined) {
                    body = parameters['groupsContainingSampleAndMolecularProfileIdentifiers'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch generic assay binary data enrichments in a molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchGenericAssayBinaryDataEnrichmentInMultipleMolecularProfilesUsingPOST
     * @param {string} enrichmentType - Type of the enrichment e.g. SAMPLE or PATIENT
     * @param {} groupsContainingSampleAndMolecularProfileIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayBinaryDataEnrichmentInMultipleMolecularProfilesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenericAssayBinaryDataEnrichmentInMultipleMolecularProfilesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayCategoricalDataEnrichmentInMultipleMolecularProfilesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic-assay-categorical-enrichments/fetch';
            if (parameters['enrichmentType'] !== undefined) {
                queryParameters['enrichmentType'] = parameters['enrichmentType'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch generic assay categorical data enrichments in a molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchGenericAssayCategoricalDataEnrichmentInMultipleMolecularProfilesUsingPOST
     * @param {string} enrichmentType - Type of the enrichment e.g. SAMPLE or PATIENT
     * @param {} groupsContainingSampleAndMolecularProfileIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayCategoricalDataEnrichmentInMultipleMolecularProfilesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic-assay-categorical-enrichments/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['enrichmentType'] !== undefined) {
                    queryParameters['enrichmentType'] = parameters['enrichmentType'];
                }
                if (parameters['groupsContainingSampleAndMolecularProfileIdentifiers'] !== undefined) {
                    body = parameters['groupsContainingSampleAndMolecularProfileIdentifiers'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch generic assay categorical data enrichments in a molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchGenericAssayCategoricalDataEnrichmentInMultipleMolecularProfilesUsingPOST
     * @param {string} enrichmentType - Type of the enrichment e.g. SAMPLE or PATIENT
     * @param {} groupsContainingSampleAndMolecularProfileIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayCategoricalDataEnrichmentInMultipleMolecularProfilesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenericAssayCategoricalDataEnrichmentInMultipleMolecularProfilesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayDataBinCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic-assay-data-bin-counts/fetch';
            if (parameters['dataBinMethod'] !== undefined) {
                queryParameters['dataBinMethod'] = parameters['dataBinMethod'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch generic assay data bin counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchGenericAssayDataBinCountsUsingPOST
     * @param {string} dataBinMethod - Method for data binning
     * @param {} genericAssayDataBinCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayDataBinCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic-assay-data-bin-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['dataBinMethod'] !== undefined) {
                    queryParameters['dataBinMethod'] = parameters['dataBinMethod'];
                }
                if (parameters['genericAssayDataBinCountFilter'] !== undefined) {
                    body = parameters['genericAssayDataBinCountFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch generic assay data bin counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchGenericAssayDataBinCountsUsingPOST
     * @param {string} dataBinMethod - Method for data binning
     * @param {} genericAssayDataBinCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayDataBinCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenericAssayDataBinCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayDataCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic-assay-data-counts/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch generic assay data counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchGenericAssayDataCountsUsingPOST
     * @param {} genericAssayDataCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayDataCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic-assay-data-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['genericAssayDataCountFilter'] !== undefined) {
                    body = parameters['genericAssayDataCountFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch generic assay data counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchGenericAssayDataCountsUsingPOST
     * @param {} genericAssayDataCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayDataCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenericAssayDataCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayEnrichmentsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/generic-assay-enrichments/fetch';
            if (parameters['enrichmentType'] !== undefined) {
                queryParameters['enrichmentType'] = parameters['enrichmentType'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch generic assay enrichments in a molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchGenericAssayEnrichmentsUsingPOST
     * @param {string} enrichmentType - Type of the enrichment e.g. SAMPLE or PATIENT
     * @param {} groupsContainingSampleAndMolecularProfileIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayEnrichmentsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/generic-assay-enrichments/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['enrichmentType'] !== undefined) {
                    queryParameters['enrichmentType'] = parameters['enrichmentType'];
                }
                if (parameters['groupsContainingSampleAndMolecularProfileIdentifiers'] !== undefined) {
                    body = parameters['groupsContainingSampleAndMolecularProfileIdentifiers'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch generic assay enrichments in a molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchGenericAssayEnrichmentsUsingPOST
     * @param {string} enrichmentType - Type of the enrichment e.g. SAMPLE or PATIENT
     * @param {} groupsContainingSampleAndMolecularProfileIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenericAssayEnrichmentsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenericAssayEnrichmentsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenesetHierarchyInfoUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/geneset-hierarchy/fetch';
            if (parameters['geneticProfileId'] !== undefined) {
                queryParameters['geneticProfileId'] = parameters['geneticProfileId'];
            }
            if (parameters['percentile'] !== undefined) {
                queryParameters['percentile'] = parameters['percentile'];
            }
            if (parameters['scoreThreshold'] !== undefined) {
                queryParameters['scoreThreshold'] = parameters['scoreThreshold'];
            }
            if (parameters['pvalueThreshold'] !== undefined) {
                queryParameters['pvalueThreshold'] = parameters['pvalueThreshold'];
            }
            if (parameters['sampleListId'] !== undefined) {
                queryParameters['sampleListId'] = parameters['sampleListId'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get gene set hierarchical organization information. I.e. how different gene sets relate to other gene sets, in a hierarchy
     * @method
     * @name CBioPortalAPIInternal#fetchGenesetHierarchyInfoUsingPOST
     * @param {string} geneticProfileId - Genetic Profile ID e.g. gbm_tcga_gsva_scores. The final hierarchy  will only include gene sets scored in the specified profile.
     * @param {integer} percentile - Percentile (for score calculation). Which percentile to use when determining the *representative score*
     * @param {number} scoreThreshold - Gene set score threshold (for absolute score value). Filters out gene sets where the GSVA(like) *representative score* is under this threshold.
     * @param {number} pvalueThreshold - p-value threshold. Filters out gene sets for which the score p-value is higher than this threshold.
     * @param {string} sampleListId - Identifier of pre-defined sample list with samples to query, e.g. brca_tcga_all
     * @param {} fillThisOneIfYouWantToSpecifyASubsetOfSamplesSampleidsCustomListOfSamplesOrPatientsToQueryEgTcgaA1A0Sd01TcgaA1A0Se01 - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenesetHierarchyInfoUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/geneset-hierarchy/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['geneticProfileId'] !== undefined) {
                    queryParameters['geneticProfileId'] = parameters['geneticProfileId'];
                }
                if (parameters['geneticProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: geneticProfileId'));
                    return;
                }
                if (parameters['percentile'] !== undefined) {
                    queryParameters['percentile'] = parameters['percentile'];
                }
                if (parameters['scoreThreshold'] !== undefined) {
                    queryParameters['scoreThreshold'] = parameters['scoreThreshold'];
                }
                if (parameters['pvalueThreshold'] !== undefined) {
                    queryParameters['pvalueThreshold'] = parameters['pvalueThreshold'];
                }
                if (parameters['sampleListId'] !== undefined) {
                    queryParameters['sampleListId'] = parameters['sampleListId'];
                }
                if (parameters['fillThisOneIfYouWantToSpecifyASubsetOfSamplesSampleidsCustomListOfSamplesOrPatientsToQueryEgTcgaA1A0Sd01TcgaA1A0Se01'] !== undefined) {
                    body = parameters['fillThisOneIfYouWantToSpecifyASubsetOfSamplesSampleidsCustomListOfSamplesOrPatientsToQueryEgTcgaA1A0Sd01TcgaA1A0Se01'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get gene set hierarchical organization information. I.e. how different gene sets relate to other gene sets, in a hierarchy
     * @method
     * @name CBioPortalAPIInternal#fetchGenesetHierarchyInfoUsingPOST
     * @param {string} geneticProfileId - Genetic Profile ID e.g. gbm_tcga_gsva_scores. The final hierarchy  will only include gene sets scored in the specified profile.
     * @param {integer} percentile - Percentile (for score calculation). Which percentile to use when determining the *representative score*
     * @param {number} scoreThreshold - Gene set score threshold (for absolute score value). Filters out gene sets where the GSVA(like) *representative score* is under this threshold.
     * @param {number} pvalueThreshold - p-value threshold. Filters out gene sets for which the score p-value is higher than this threshold.
     * @param {string} sampleListId - Identifier of pre-defined sample list with samples to query, e.g. brca_tcga_all
     * @param {} fillThisOneIfYouWantToSpecifyASubsetOfSamplesSampleidsCustomListOfSamplesOrPatientsToQueryEgTcgaA1A0Sd01TcgaA1A0Se01 - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenesetHierarchyInfoUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenesetHierarchyInfoUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllGenesetsUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genesets';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all gene sets
     * @method
     * @name CBioPortalAPIInternal#getAllGenesetsUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllGenesetsUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genesets';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all gene sets
     * @method
     * @name CBioPortalAPIInternal#getAllGenesetsUsingGET
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllGenesetsUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllGenesetsUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenesetsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genesets/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch gene sets by ID
     * @method
     * @name CBioPortalAPIInternal#fetchGenesetsUsingPOST
     * @param {} genesetIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenesetsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genesets/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['genesetIds'] !== undefined) {
                    body = parameters['genesetIds'];
                }
                if (parameters['genesetIds'] === undefined) {
                    reject(new Error('Missing required  parameter: genesetIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch gene sets by ID
     * @method
     * @name CBioPortalAPIInternal#fetchGenesetsUsingPOST
     * @param {} genesetIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenesetsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenesetsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getGenesetVersionUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genesets/version';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get the geneset version
     * @method
     * @name CBioPortalAPIInternal#getGenesetVersionUsingGET
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getGenesetVersionUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genesets/version';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get the geneset version
     * @method
     * @name CBioPortalAPIInternal#getGenesetVersionUsingGET
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getGenesetVersionUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getGenesetVersionUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getGenesetUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genesets/{genesetId}';
            path = path.replace('{genesetId}', parameters['genesetId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get a gene set
     * @method
     * @name CBioPortalAPIInternal#getGenesetUsingGET
     * @param {string} genesetId - Gene set ID e.g. GNF2_ZAP70
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getGenesetUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genesets/{genesetId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{genesetId}', parameters['genesetId'] + '');
                if (parameters['genesetId'] === undefined) {
                    reject(new Error('Missing required  parameter: genesetId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get a gene set
     * @method
     * @name CBioPortalAPIInternal#getGenesetUsingGET
     * @param {string} genesetId - Gene set ID e.g. GNF2_ZAP70
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getGenesetUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getGenesetUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCorrelatedGenesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genesets/{genesetId}/expression-correlation/fetch';
            path = path.replace('{genesetId}', parameters['genesetId'] + '');
            if (parameters['geneticProfileId'] !== undefined) {
                queryParameters['geneticProfileId'] = parameters['geneticProfileId'];
            }
            if (parameters['correlationThreshold'] !== undefined) {
                queryParameters['correlationThreshold'] = parameters['correlationThreshold'];
            }
            if (parameters['sampleListId'] !== undefined) {
                queryParameters['sampleListId'] = parameters['sampleListId'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get the genes in a gene set that have expression correlated to the gene set scores (calculated using Spearman's correlation)
     * @method
     * @name CBioPortalAPIInternal#fetchCorrelatedGenesUsingPOST
     * @param {string} genesetId - Gene set ID, e.g. HINATA_NFKB_MATRIX.
     * @param {string} geneticProfileId - Genetic Profile ID e.g. gbm_tcga_gsva_scores
     * @param {number} correlationThreshold - Correlation threshold (for absolute correlation value, Spearman correlation)
     * @param {string} sampleListId - Identifier of pre-defined sample list with samples to query, e.g. brca_tcga_all
     * @param {} fillThisOneIfYouWantToSpecifyASubsetOfSamplesSampleidsCustomListOfSamplesOrPatientsToQueryEgTcgaA1A0Sd01TcgaA1A0Se01 - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCorrelatedGenesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genesets/{genesetId}/expression-correlation/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{genesetId}', parameters['genesetId'] + '');
                if (parameters['genesetId'] === undefined) {
                    reject(new Error('Missing required  parameter: genesetId'));
                    return;
                }
                if (parameters['geneticProfileId'] !== undefined) {
                    queryParameters['geneticProfileId'] = parameters['geneticProfileId'];
                }
                if (parameters['geneticProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: geneticProfileId'));
                    return;
                }
                if (parameters['correlationThreshold'] !== undefined) {
                    queryParameters['correlationThreshold'] = parameters['correlationThreshold'];
                }
                if (parameters['sampleListId'] !== undefined) {
                    queryParameters['sampleListId'] = parameters['sampleListId'];
                }
                if (parameters['fillThisOneIfYouWantToSpecifyASubsetOfSamplesSampleidsCustomListOfSamplesOrPatientsToQueryEgTcgaA1A0Sd01TcgaA1A0Se01'] !== undefined) {
                    body = parameters['fillThisOneIfYouWantToSpecifyASubsetOfSamplesSampleidsCustomListOfSamplesOrPatientsToQueryEgTcgaA1A0Sd01TcgaA1A0Se01'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get the genes in a gene set that have expression correlated to the gene set scores (calculated using Spearman's correlation)
     * @method
     * @name CBioPortalAPIInternal#fetchCorrelatedGenesUsingPOST
     * @param {string} genesetId - Gene set ID, e.g. HINATA_NFKB_MATRIX.
     * @param {string} geneticProfileId - Genetic Profile ID e.g. gbm_tcga_gsva_scores
     * @param {number} correlationThreshold - Correlation threshold (for absolute correlation value, Spearman correlation)
     * @param {string} sampleListId - Identifier of pre-defined sample list with samples to query, e.g. brca_tcga_all
     * @param {} fillThisOneIfYouWantToSpecifyASubsetOfSamplesSampleidsCustomListOfSamplesOrPatientsToQueryEgTcgaA1A0Sd01TcgaA1A0Se01 - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCorrelatedGenesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchCorrelatedGenesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGeneticDataItemsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genetic-profiles/{geneticProfileId}/geneset-genetic-data/fetch';
            path = path.replace('{geneticProfileId}', parameters['geneticProfileId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch gene set "genetic data" items (gene set scores) by profile Id, gene set ids and sample ids
     * @method
     * @name CBioPortalAPIInternal#fetchGeneticDataItemsUsingPOST
     * @param {string} geneticProfileId - Genetic profile ID, e.g. gbm_tcga_gsva_scores
     * @param {} genesetDataFilterCriteria - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGeneticDataItemsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genetic-profiles/{geneticProfileId}/geneset-genetic-data/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{geneticProfileId}', parameters['geneticProfileId'] + '');
                if (parameters['geneticProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: geneticProfileId'));
                    return;
                }
                if (parameters['genesetDataFilterCriteria'] !== undefined) {
                    body = parameters['genesetDataFilterCriteria'];
                }
                if (parameters['genesetDataFilterCriteria'] === undefined) {
                    reject(new Error('Missing required  parameter: genesetDataFilterCriteria'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch gene set "genetic data" items (gene set scores) by profile Id, gene set ids and sample ids
     * @method
     * @name CBioPortalAPIInternal#fetchGeneticDataItemsUsingPOST
     * @param {string} geneticProfileId - Genetic profile ID, e.g. gbm_tcga_gsva_scores
     * @param {} genesetDataFilterCriteria - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGeneticDataItemsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGeneticDataItemsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenomicDataBinCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genomic-data-bin-counts/fetch';
            if (parameters['dataBinMethod'] !== undefined) {
                queryParameters['dataBinMethod'] = parameters['dataBinMethod'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch genomic data bin counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchGenomicDataBinCountsUsingPOST
     * @param {string} dataBinMethod - Method for data binning
     * @param {} genomicDataBinCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenomicDataBinCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genomic-data-bin-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['dataBinMethod'] !== undefined) {
                    queryParameters['dataBinMethod'] = parameters['dataBinMethod'];
                }
                if (parameters['genomicDataBinCountFilter'] !== undefined) {
                    body = parameters['genomicDataBinCountFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch genomic data bin counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchGenomicDataBinCountsUsingPOST
     * @param {string} dataBinMethod - Method for data binning
     * @param {} genomicDataBinCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenomicDataBinCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenomicDataBinCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenomicDataCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/genomic-data-counts/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch genomic data counts by GenomicDataCountFilter
     * @method
     * @name CBioPortalAPIInternal#fetchGenomicDataCountsUsingPOST
     * @param {} genomicDataCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenomicDataCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/genomic-data-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['genomicDataCountFilter'] !== undefined) {
                    body = parameters['genomicDataCountFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch genomic data counts by GenomicDataCountFilter
     * @method
     * @name CBioPortalAPIInternal#fetchGenomicDataCountsUsingPOST
     * @param {} genomicDataCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchGenomicDataCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchGenomicDataCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMolecularProfileSampleCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profile-sample-counts/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch sample counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchMolecularProfileSampleCountsUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMolecularProfileSampleCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profile-sample-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch sample counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchMolecularProfileSampleCountsUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMolecularProfileSampleCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchMolecularProfileSampleCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCoExpressionsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/co-expressions/fetch';
            if (parameters['molecularProfileIdA'] !== undefined) {
                queryParameters['molecularProfileIdA'] = parameters['molecularProfileIdA'];
            }
            if (parameters['molecularProfileIdB'] !== undefined) {
                queryParameters['molecularProfileIdB'] = parameters['molecularProfileIdB'];
            }
            if (parameters['threshold'] !== undefined) {
                queryParameters['threshold'] = parameters['threshold'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Calculates correlations between a genetic entity from a specific profile and another profile from the same study
     * @method
     * @name CBioPortalAPIInternal#fetchCoExpressionsUsingPOST
     * @param {string} molecularProfileIdA - Molecular Profile ID from the Genetic Entity referenced in the co-expression filter e.g. acc_tcga_rna_seq_v2_mrna
     * @param {string} molecularProfileIdB - Molecular Profile ID (can be the same as molecularProfileIdA) e.g. acc_tcga_rna_seq_v2_mrna
     * @param {number} threshold - Threshold
     * @param {} coExpressionFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCoExpressionsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/co-expressions/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['molecularProfileIdA'] !== undefined) {
                    queryParameters['molecularProfileIdA'] = parameters['molecularProfileIdA'];
                }
                if (parameters['molecularProfileIdA'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileIdA'));
                    return;
                }
                if (parameters['molecularProfileIdB'] !== undefined) {
                    queryParameters['molecularProfileIdB'] = parameters['molecularProfileIdB'];
                }
                if (parameters['molecularProfileIdB'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileIdB'));
                    return;
                }
                if (parameters['threshold'] !== undefined) {
                    queryParameters['threshold'] = parameters['threshold'];
                }
                if (parameters['coExpressionFilter'] !== undefined) {
                    body = parameters['coExpressionFilter'];
                }
                if (parameters['coExpressionFilter'] === undefined) {
                    reject(new Error('Missing required  parameter: coExpressionFilter'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Calculates correlations between a genetic entity from a specific profile and another profile from the same study
     * @method
     * @name CBioPortalAPIInternal#fetchCoExpressionsUsingPOST
     * @param {string} molecularProfileIdA - Molecular Profile ID from the Genetic Entity referenced in the co-expression filter e.g. acc_tcga_rna_seq_v2_mrna
     * @param {string} molecularProfileIdB - Molecular Profile ID (can be the same as molecularProfileIdA) e.g. acc_tcga_rna_seq_v2_mrna
     * @param {number} threshold - Threshold
     * @param {} coExpressionFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCoExpressionsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchCoExpressionsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCopyNumberCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/discrete-copy-number-counts/fetch';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get counts of specific genes and alterations within a CNA molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchCopyNumberCountsUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_gistic
     * @param {} copyNumberCountIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCopyNumberCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/discrete-copy-number-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['copyNumberCountIdentifiers'] !== undefined) {
                    body = parameters['copyNumberCountIdentifiers'];
                }
                if (parameters['copyNumberCountIdentifiers'] === undefined) {
                    reject(new Error('Missing required  parameter: copyNumberCountIdentifiers'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get counts of specific genes and alterations within a CNA molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchCopyNumberCountsUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_gistic
     * @param {} copyNumberCountIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCopyNumberCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchCopyNumberCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMrnaPercentileUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/mrna-percentile/fetch';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters['sampleId'] !== undefined) {
                queryParameters['sampleId'] = parameters['sampleId'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get mRNA expression percentiles for list of genes for a sample
     * @method
     * @name CBioPortalAPIInternal#fetchMrnaPercentileUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_rna_seq_v2_mrna
     * @param {string} sampleId - Sample ID e.g. TCGA-OR-A5J2-01
     * @param {} entrezGeneIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMrnaPercentileUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/mrna-percentile/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['sampleId'] !== undefined) {
                    queryParameters['sampleId'] = parameters['sampleId'];
                }
                if (parameters['sampleId'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleId'));
                    return;
                }
                if (parameters['entrezGeneIds'] !== undefined) {
                    body = parameters['entrezGeneIds'];
                }
                if (parameters['entrezGeneIds'] === undefined) {
                    reject(new Error('Missing required  parameter: entrezGeneIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get mRNA expression percentiles for list of genes for a sample
     * @method
     * @name CBioPortalAPIInternal#fetchMrnaPercentileUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_rna_seq_v2_mrna
     * @param {string} sampleId - Sample ID e.g. TCGA-OR-A5J2-01
     * @param {} entrezGeneIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMrnaPercentileUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchMrnaPercentileUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutationSpectrumsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/mutation-spectrums/fetch';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch mutation spectrums in a molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchMutationSpectrumsUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_mutations
     * @param {} mutationSpectrumFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutationSpectrumsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/mutation-spectrums/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['mutationSpectrumFilter'] !== undefined) {
                    body = parameters['mutationSpectrumFilter'];
                }
                if (parameters['mutationSpectrumFilter'] === undefined) {
                    reject(new Error('Missing required  parameter: mutationSpectrumFilter'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch mutation spectrums in a molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchMutationSpectrumsUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_mutations
     * @param {} mutationSpectrumFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutationSpectrumsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchMutationSpectrumsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchVariantCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/molecular-profiles/{molecularProfileId}/variant-counts/fetch';
            path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get counts of specific variants within a mutation molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchVariantCountsUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_mutations
     * @param {} variantCountIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchVariantCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/molecular-profiles/{molecularProfileId}/variant-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{molecularProfileId}', parameters['molecularProfileId'] + '');
                if (parameters['molecularProfileId'] === undefined) {
                    reject(new Error('Missing required  parameter: molecularProfileId'));
                    return;
                }
                if (parameters['variantCountIdentifiers'] !== undefined) {
                    body = parameters['variantCountIdentifiers'];
                }
                if (parameters['variantCountIdentifiers'] === undefined) {
                    reject(new Error('Missing required  parameter: variantCountIdentifiers'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get counts of specific variants within a mutation molecular profile
     * @method
     * @name CBioPortalAPIInternal#fetchVariantCountsUsingPOST
     * @param {string} molecularProfileId - Molecular Profile ID e.g. acc_tcga_mutations
     * @param {} variantCountIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchVariantCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchVariantCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutatedGenesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/mutated-genes/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch mutated genes by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchMutatedGenesUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutatedGenesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/mutated-genes/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch mutated genes by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchMutatedGenesUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutatedGenesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchMutatedGenesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutationCountsByPositionUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/mutation-counts-by-position/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch mutation counts in all studies by gene and position
     * @method
     * @name CBioPortalAPIInternal#fetchMutationCountsByPositionUsingPOST
     * @param {} mutationPositionIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutationCountsByPositionUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/mutation-counts-by-position/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['mutationPositionIdentifiers'] !== undefined) {
                    body = parameters['mutationPositionIdentifiers'];
                }
                if (parameters['mutationPositionIdentifiers'] === undefined) {
                    reject(new Error('Missing required  parameter: mutationPositionIdentifiers'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch mutation counts in all studies by gene and position
     * @method
     * @name CBioPortalAPIInternal#fetchMutationCountsByPositionUsingPOST
     * @param {} mutationPositionIdentifiers - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutationCountsByPositionUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchMutationCountsByPositionUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutationDataCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/mutation-data-counts/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch mutation data counts by GenomicDataCountFilter
     * @method
     * @name CBioPortalAPIInternal#fetchMutationDataCountsUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} genomicDataCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutationDataCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/mutation-data-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['genomicDataCountFilter'] !== undefined) {
                    body = parameters['genomicDataCountFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch mutation data counts by GenomicDataCountFilter
     * @method
     * @name CBioPortalAPIInternal#fetchMutationDataCountsUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} genomicDataCountFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchMutationDataCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchMutationDataCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllReferenceGenomeGenesUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/reference-genome-genes/{genomeName}';
            path = path.replace('{genomeName}', parameters['genomeName'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all reference genes
     * @method
     * @name CBioPortalAPIInternal#getAllReferenceGenomeGenesUsingGET
     * @param {string} genomeName - Name of Reference Genome hg19
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllReferenceGenomeGenesUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/reference-genome-genes/{genomeName}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{genomeName}', parameters['genomeName'] + '');
                if (parameters['genomeName'] === undefined) {
                    reject(new Error('Missing required  parameter: genomeName'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all reference genes
     * @method
     * @name CBioPortalAPIInternal#getAllReferenceGenomeGenesUsingGET
     * @param {string} genomeName - Name of Reference Genome hg19
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllReferenceGenomeGenesUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllReferenceGenomeGenesUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchReferenceGenomeGenesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/reference-genome-genes/{genomeName}/fetch';
            path = path.replace('{genomeName}', parameters['genomeName'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch genes of reference genome of interest
     * @method
     * @name CBioPortalAPIInternal#fetchReferenceGenomeGenesUsingPOST
     * @param {string} genomeName - Name of Reference Genome hg19
     * @param {} geneIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchReferenceGenomeGenesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/reference-genome-genes/{genomeName}/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                path = path.replace('{genomeName}', parameters['genomeName'] + '');
                if (parameters['genomeName'] === undefined) {
                    reject(new Error('Missing required  parameter: genomeName'));
                    return;
                }
                if (parameters['geneIds'] !== undefined) {
                    body = parameters['geneIds'];
                }
                if (parameters['geneIds'] === undefined) {
                    reject(new Error('Missing required  parameter: geneIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch genes of reference genome of interest
     * @method
     * @name CBioPortalAPIInternal#fetchReferenceGenomeGenesUsingPOST
     * @param {string} genomeName - Name of Reference Genome hg19
     * @param {} geneIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchReferenceGenomeGenesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchReferenceGenomeGenesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getReferenceGenomeGeneUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/reference-genome-genes/{genomeName}/{geneId}';
            path = path.replace('{genomeName}', parameters['genomeName'] + '');
            path = path.replace('{geneId}', parameters['geneId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get a gene of a reference genome of interest
     * @method
     * @name CBioPortalAPIInternal#getReferenceGenomeGeneUsingGET
     * @param {string} genomeName - Name of Reference Genome hg19
     * @param {integer} geneId - Entrez Gene ID 207
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getReferenceGenomeGeneUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/reference-genome-genes/{genomeName}/{geneId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{genomeName}', parameters['genomeName'] + '');
                if (parameters['genomeName'] === undefined) {
                    reject(new Error('Missing required  parameter: genomeName'));
                    return;
                }
                path = path.replace('{geneId}', parameters['geneId'] + '');
                if (parameters['geneId'] === undefined) {
                    reject(new Error('Missing required  parameter: geneId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get a gene of a reference genome of interest
     * @method
     * @name CBioPortalAPIInternal#getReferenceGenomeGeneUsingGET
     * @param {string} genomeName - Name of Reference Genome hg19
     * @param {integer} geneId - Entrez Gene ID 207
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getReferenceGenomeGeneUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getReferenceGenomeGeneUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchResourceDefinitionsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/resource-definitions/fetch';
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all resource definitions for specified studies
     * @method
     * @name CBioPortalAPIInternal#fetchResourceDefinitionsUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchResourceDefinitionsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/resource-definitions/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['studyIds'] !== undefined) {
                    body = parameters['studyIds'];
                }
                if (parameters['studyIds'] === undefined) {
                    reject(new Error('Missing required  parameter: studyIds'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all resource definitions for specified studies
     * @method
     * @name CBioPortalAPIInternal#fetchResourceDefinitionsUsingPOST
     * @param {string} projection - Level of detail of the response
     * @param {} studyIds - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchResourceDefinitionsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchResourceDefinitionsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCaseListCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/sample-lists-counts/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch case list sample counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchCaseListCountsUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCaseListCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/sample-lists-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch case list sample counts by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchCaseListCountsUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchCaseListCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchCaseListCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchStructuralVariantsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/structural-variant/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch structural variants for entrezGeneIds and molecularProfileIds or sampleMolecularIdentifiers
     * @method
     * @name CBioPortalAPIInternal#fetchStructuralVariantsUsingPOST
     * @param {} structuralVariantFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchStructuralVariantsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/structural-variant/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['structuralVariantFilter'] !== undefined) {
                    body = parameters['structuralVariantFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch structural variants for entrezGeneIds and molecularProfileIds or sampleMolecularIdentifiers
     * @method
     * @name CBioPortalAPIInternal#fetchStructuralVariantsUsingPOST
     * @param {} structuralVariantFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchStructuralVariantsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchStructuralVariantsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchStructuralVariantCountsUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/structuralvariant-counts/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch structural variant genes by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchStructuralVariantCountsUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchStructuralVariantCountsUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/structuralvariant-counts/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch structural variant genes by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchStructuralVariantCountsUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchStructuralVariantCountsUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchStructuralVariantCountsUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchStructuralVariantGenesUsingPOSTURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/structuralvariant-genes/fetch';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Fetch structural variant genes by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchStructuralVariantGenesUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchStructuralVariantGenesUsingPOSTWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/structuralvariant-genes/fetch';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (parameters['studyViewFilter'] !== undefined) {
                    body = parameters['studyViewFilter'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Fetch structural variant genes by study view filter
     * @method
     * @name CBioPortalAPIInternal#fetchStructuralVariantGenesUsingPOST
     * @param {} studyViewFilter - A web service for supplying JSON formatted data to cBioPortal clients. Please note that this API is currently in beta and subject to change.
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "fetchStructuralVariantGenesUsingPOST", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.fetchStructuralVariantGenesUsingPOSTWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllClinicalEventsInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/clinical-events';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all clinical events in a study
     * @method
     * @name CBioPortalAPIInternal#getAllClinicalEventsInStudyUsingGET
     * @param {string} studyId - Study ID e.g. lgg_ucsf_2014
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllClinicalEventsInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/clinical-events';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all clinical events in a study
     * @method
     * @name CBioPortalAPIInternal#getAllClinicalEventsInStudyUsingGET
     * @param {string} studyId - Study ID e.g. lgg_ucsf_2014
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllClinicalEventsInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllClinicalEventsInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllClinicalEventsOfPatientInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/patients/{patientId}/clinical-events';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{patientId}', parameters['patientId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all clinical events of a patient in a study
     * @method
     * @name CBioPortalAPIInternal#getAllClinicalEventsOfPatientInStudyUsingGET
     * @param {string} studyId - Study ID e.g. lgg_ucsf_2014
     * @param {string} patientId - Patient ID e.g. P01
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllClinicalEventsOfPatientInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/patients/{patientId}/clinical-events';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{patientId}', parameters['patientId'] + '');
                if (parameters['patientId'] === undefined) {
                    reject(new Error('Missing required  parameter: patientId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all clinical events of a patient in a study
     * @method
     * @name CBioPortalAPIInternal#getAllClinicalEventsOfPatientInStudyUsingGET
     * @param {string} studyId - Study ID e.g. lgg_ucsf_2014
     * @param {string} patientId - Patient ID e.g. P01
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllClinicalEventsOfPatientInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllClinicalEventsOfPatientInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllResourceDataOfPatientInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/patients/{patientId}/resource-data';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{patientId}', parameters['patientId'] + '');
            if (parameters['resourceId'] !== undefined) {
                queryParameters['resourceId'] = parameters['resourceId'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all resource data of a patient in a study
     * @method
     * @name CBioPortalAPIInternal#getAllResourceDataOfPatientInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} patientId - Patient ID e.g. TCGA-OR-A5J2
     * @param {string} resourceId - Resource ID
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllResourceDataOfPatientInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/patients/{patientId}/resource-data';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{patientId}', parameters['patientId'] + '');
                if (parameters['patientId'] === undefined) {
                    reject(new Error('Missing required  parameter: patientId'));
                    return;
                }
                if (parameters['resourceId'] !== undefined) {
                    queryParameters['resourceId'] = parameters['resourceId'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all resource data of a patient in a study
     * @method
     * @name CBioPortalAPIInternal#getAllResourceDataOfPatientInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} patientId - Patient ID e.g. TCGA-OR-A5J2
     * @param {string} resourceId - Resource ID
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllResourceDataOfPatientInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllResourceDataOfPatientInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllStudyResourceDataInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/resource-data';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['resourceId'] !== undefined) {
                queryParameters['resourceId'] = parameters['resourceId'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all resource data for a study
     * @method
     * @name CBioPortalAPIInternal#getAllStudyResourceDataInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} resourceId - Resource ID
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllStudyResourceDataInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/resource-data';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['resourceId'] !== undefined) {
                    queryParameters['resourceId'] = parameters['resourceId'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all resource data for a study
     * @method
     * @name CBioPortalAPIInternal#getAllStudyResourceDataInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} resourceId - Resource ID
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllStudyResourceDataInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllStudyResourceDataInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllResourceDefinitionsInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/resource-definitions';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all resource definitions in the specified study
     * @method
     * @name CBioPortalAPIInternal#getAllResourceDefinitionsInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllResourceDefinitionsInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/resource-definitions';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all resource definitions in the specified study
     * @method
     * @name CBioPortalAPIInternal#getAllResourceDefinitionsInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllResourceDefinitionsInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllResourceDefinitionsInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getResourceDefinitionInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/resource-definitions/{resourceId}';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{resourceId}', parameters['resourceId'] + '');
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get specified resource definition
     * @method
     * @name CBioPortalAPIInternal#getResourceDefinitionInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} resourceId - Resource ID
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getResourceDefinitionInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/resource-definitions/{resourceId}';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{resourceId}', parameters['resourceId'] + '');
                if (parameters['resourceId'] === undefined) {
                    reject(new Error('Missing required  parameter: resourceId'));
                    return;
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get specified resource definition
     * @method
     * @name CBioPortalAPIInternal#getResourceDefinitionInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} resourceId - Resource ID
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getResourceDefinitionInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getResourceDefinitionInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllResourceDataOfSampleInStudyUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/samples/{sampleId}/resource-data';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            path = path.replace('{sampleId}', parameters['sampleId'] + '');
            if (parameters['resourceId'] !== undefined) {
                queryParameters['resourceId'] = parameters['resourceId'];
            }
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get all resource data of a sample in a study
     * @method
     * @name CBioPortalAPIInternal#getAllResourceDataOfSampleInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} sampleId - Sample ID e.g. TCGA-OR-A5J2-01
     * @param {string} resourceId - Resource ID
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllResourceDataOfSampleInStudyUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/samples/{sampleId}/resource-data';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                path = path.replace('{sampleId}', parameters['sampleId'] + '');
                if (parameters['sampleId'] === undefined) {
                    reject(new Error('Missing required  parameter: sampleId'));
                    return;
                }
                if (parameters['resourceId'] !== undefined) {
                    queryParameters['resourceId'] = parameters['resourceId'];
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get all resource data of a sample in a study
     * @method
     * @name CBioPortalAPIInternal#getAllResourceDataOfSampleInStudyUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} sampleId - Sample ID e.g. TCGA-OR-A5J2-01
     * @param {string} resourceId - Resource ID
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllResourceDataOfSampleInStudyUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllResourceDataOfSampleInStudyUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getSignificantCopyNumberRegionsUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/significant-copy-number-regions';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get significant copy number alteration regions in a study
     * @method
     * @name CBioPortalAPIInternal#getSignificantCopyNumberRegionsUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getSignificantCopyNumberRegionsUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/significant-copy-number-regions';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get significant copy number alteration regions in a study
     * @method
     * @name CBioPortalAPIInternal#getSignificantCopyNumberRegionsUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getSignificantCopyNumberRegionsUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getSignificantCopyNumberRegionsUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getSignificantlyMutatedGenesUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/studies/{studyId}/significantly-mutated-genes';
            path = path.replace('{studyId}', parameters['studyId'] + '');
            if (parameters['projection'] !== undefined) {
                queryParameters['projection'] = parameters['projection'];
            }
            if (parameters['pageSize'] !== undefined) {
                queryParameters['pageSize'] = parameters['pageSize'];
            }
            if (parameters['pageNumber'] !== undefined) {
                queryParameters['pageNumber'] = parameters['pageNumber'];
            }
            if (parameters['sortBy'] !== undefined) {
                queryParameters['sortBy'] = parameters['sortBy'];
            }
            if (parameters['direction'] !== undefined) {
                queryParameters['direction'] = parameters['direction'];
            }
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get significantly mutated genes in a study
     * @method
     * @name CBioPortalAPIInternal#getSignificantlyMutatedGenesUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getSignificantlyMutatedGenesUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/studies/{studyId}/significantly-mutated-genes';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                path = path.replace('{studyId}', parameters['studyId'] + '');
                if (parameters['studyId'] === undefined) {
                    reject(new Error('Missing required  parameter: studyId'));
                    return;
                }
                if (parameters['projection'] !== undefined) {
                    queryParameters['projection'] = parameters['projection'];
                }
                if (parameters['pageSize'] !== undefined) {
                    queryParameters['pageSize'] = parameters['pageSize'];
                }
                if (parameters['pageNumber'] !== undefined) {
                    queryParameters['pageNumber'] = parameters['pageNumber'];
                }
                if (parameters['sortBy'] !== undefined) {
                    queryParameters['sortBy'] = parameters['sortBy'];
                }
                if (parameters['direction'] !== undefined) {
                    queryParameters['direction'] = parameters['direction'];
                }
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get significantly mutated genes in a study
     * @method
     * @name CBioPortalAPIInternal#getSignificantlyMutatedGenesUsingGET
     * @param {string} studyId - Study ID e.g. acc_tcga
     * @param {string} projection - Level of detail of the response
     * @param {integer} pageSize - Page size of the result list
     * @param {integer} pageNumber - Page number of the result list
     * @param {string} sortBy - Name of the property that the result list is sorted by
     * @param {string} direction - Direction of the sort
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getSignificantlyMutatedGenesUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getSignificantlyMutatedGenesUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllTimestampsUsingGETURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var queryParameters = {};
            var path = '/api/timestamps';
            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                    var parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
            }
            var keys = Object.keys(queryParameters);
            return this.domain + path + (keys.length > 0 ? '?' + (keys.map(function (key) { return key + '=' + encodeURIComponent(queryParameters[key]); }).join('&')) : '');
        }
    });
    /**
     * Get the last time each static resource was updated
     * @method
     * @name CBioPortalAPIInternal#getAllTimestampsUsingGET
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllTimestampsUsingGETWithHttpInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            var domain = parameters.$domain ? parameters.$domain : this.domain;
            var errorHandlers = this.errorHandlers;
            var request = this.request;
            var path = '/api/timestamps';
            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};
            return new Promise(function (resolve, reject) {
                headers['Accept'] = 'application/json';
                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
                }
                request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, errorHandlers);
            });
        }
    });
    /**
     * Get the last time each static resource was updated
     * @method
     * @name CBioPortalAPIInternal#getAllTimestampsUsingGET
     */
    Object.defineProperty(CBioPortalAPIInternal.prototype, "getAllTimestampsUsingGET", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parameters) {
            return this.getAllTimestampsUsingGETWithHttpInfo(parameters).then(function (response) {
                return response.body;
            });
        }
    });
    return CBioPortalAPIInternal;
}());

export { CBioPortalAPI, CBioPortalAPIInternal };
//# sourceMappingURL=index.es.js.map
